<template>
  <div v-if="fillsViewPermission"
    class="fillgrid-view" :class="{ 'sidebar-collapsed': leftSidebarCollapsed }">
    <div class="left-sidebar">
      <div class="toggle-button d-flex justify-content-center align-items-center" @click="leftSidebarCollapsed = !leftSidebarCollapsed">
        <i class="fas fa-caret-right" v-if="leftSidebarCollapsed"></i>
        <i class="fas fa-caret-left" v-else></i>
      </div>
      <div class="template-name">
        <i class="fal fa-arrow-circle-left" @click="backToTemplates" title="Cambiar template"></i>
        <span class="text-truncate" :title="templateTitle">{{ templateTitle }}</span>
      </div>

      <!-- FILTERS AND VIEWS -->
      <div class="filters">
        <b-tabs justified small>
          <b-tab>
            <template v-slot:title>
              <i class="far fa-search"></i> Búsqueda
            </template>
            <FillgridFiltersComponent
              v-if="columns.length"
              :templateId="templateId"
              :viewId="viewSelected"
              :columns="columns"
              :loading="loadingData || downloadingData"
              :identsNames="idents"
              :identsLabels="identsLabels"
              :users="users"
              :activeUsersNames="activeUsersNames"
              :searches="searches"
              :searchIdSelected="searchIdSelected"
              :searchUpdated="searchUpdated"
              :isUpdating="isUpdating"
              @search="newSearch"
              @simulate-search="simulateSearch"
              @save-search="saveSearch"
              @delete-search="deleteSearch"
              @update-search="setSearchIdSelected"
              @update-view="setViewIdSelected"
              @search-updated="setSearchUpdated"
              @update-users="updateAllUsersAndActiveUsers"
            />
          </b-tab>
          <b-tab>
            <template v-slot:title>
              <i class="fad fa-line-columns"></i> Vistas
            </template>

            <FillgridViews
              :template="templateId"
              :identColumns="idents"
              :columns="columns"
              :noVisibleColumns="noVisibleColumns"
              :viewId="viewSelected"
              @apply="applyView"
              :autoSave="autoSaveView"
              @auto-saved="updateAutoSaveView(false)"
              v-if="columns.length"/>
          </b-tab>
        </b-tabs>
      </div>
    </div>

    <div class="right-side">
      <!-- TOP BUTTONS BAR -->
      <div class="top-tool-bar" v-if="!historyActive && !mapViewActive">
        <div class="action d-none d-lg-block" @click="openAssignUser" v-if="assignFillsPermission"><i class="fal fa-user-check"></i> Asignar</div>
        <div class="action d-none d-lg-block" @click="openUpdatesMultiple(FILL_UPDATE_MODE.MODIFY)" v-if="modifyFillsPermission"><i class="fal fa-file-edit"></i> Modificar</div>
        <div class="action d-none d-lg-block" @click="openUpdatesMultiple(FILL_UPDATE_MODE.MANAGE)" v-if="hasPermissionToQuickEdit && isThereSomeQuickEditField"><i class="fal fa-file-edit"></i> Gestionar</div>
        <div class="action d-none d-lg-block" @click="openDeleteRows" title="Eliminar" v-if="deleteFillsPermission"><i class="fal fa-trash-alt"></i> Eliminar</div>
        <div class="action d-none d-lg-block" @click="openChangeStatusRows" title="Generar PDF" v-if="(pdfFillsPermission && isThereSomePdfField)"><i class="fal fa-file-pdf"></i></div>
        <div class="action d-none d-lg-block" @click="toggleDisplayImages" :class="{ active: displayImages }" :title="displayImagesBtnTitle"><i class="fal fa-camera"></i></div>
        <div class="action d-none d-lg-block" @click="() => mapViewActive = true" :title="getTitleShowMapView()" v-if="isTemplateWithLocation"><i class="fal fa-map"></i></div>
        <div class="action d-none d-lg-block" v-if="readAttachmentsPermission"
          @click="showAsyncTaskModalEvent(true)"
          :title="totalPages ? 'Descargar registros' : 'Descargar registros (No hay registros para descargar)'"
          ><i class="fal fa-file-spreadsheet"></i></div>
        <!--div class="action d-none d-lg-block" @click="openDownloadFiles" title="Descargar achivos"><i class="fal fa-file-download"></i></div-->
        <div class="action d-none d-lg-block" v-if="integrationTaskPermissions" title="Integrar registros" @click="openModalIntegration"><i class="fal fa-file-upload"></i></div>
        <div class="action d-none d-lg-block" title="Nuevo registro" v-if="createFillsPermission" @click="() => openFillInTypist(undefined)"><i class="fal fa-file-plus"></i></div>

        <div class="actions-collapsed d-lg-none">
          <b-dropdown class="shadow-sm" text="Acciones">
            <b-dropdown-item @click="openAssignUser" v-if="assignFillsPermission">Asignar</b-dropdown-item>
            <b-dropdown-item @click="openUpdatesMultiple(FILL_UPDATE_MODE.MODIFY)" v-if="modifyFillsPermission">Modificar</b-dropdown-item>
            <b-dropdown-item @click="openUpdatesMultiple(FILL_UPDATE_MODE.MANAGE)" v-if="hasPermissionToQuickEdit && isThereSomeQuickEditField">Gestionar</b-dropdown-item>
            <b-dropdown-item @click="openDeleteRows" v-if="deleteFillsPermission">Eliminar</b-dropdown-item>
            <b-dropdown-item @click="toggleDisplayImages">{{ displayImagesBtnTitle }}</b-dropdown-item>
            <b-dropdown-item v-if="readAttachmentsPermission"
              @click="showAsyncTaskModalEvent(true)"
              :title="totalPages ? '' : 'No hay registros para descargar'"
              >Descargar registros</b-dropdown-item>
            <!--b-dropdown-item @click="openDownloadFiles">Descargar achivos</b-dropdown-item-->
            <b-dropdown-item v-if="integrationTaskPermissions" @click="openModalIntegration">Integrar registros</b-dropdown-item>
            <b-dropdown-item @click="() => openFillInTypist(undefined)" v-if="createFillsPermission">Nuevo</b-dropdown-item>
          </b-dropdown>
        </div>

        <TopToolBarPaginator
          :key="paginatorKey"
          :totalItems="totalItems"
          :pageSize="PAGE_SIZE"
          :name="'Tareas por página:'"
          :pageSizes="[25, 50 , 75, 100]"
          @sizeChange="changeSize"
          @pageChange="loadPage"
          v-b-tooltip.hover.left="'Total de registros: ' + totalItems"
          style="z-index: 0"
          :isCursorBased="true"/>
      </div>

      <div class="top-tool-bar" v-if="historyActive">
        <template v-if="hasPermissionToReadFills">
          <div class="action d-lg-block" @click="closeHistory" title="Cerrar histórico"><i class="fal fa-arrow-circle-left"></i> Cerrar histórico</div>
          <div class="action d-lg-block" @click="() => loadHistoryDataByName()" title="Refrescar histórico"><i class="fal fa-sync"></i></div>
        </template>
      </div>

      <div class="top-tool-bar" v-if="mapViewActive">
        <div class="action d-lg-block" @click="mapViewActive = false" :title="getTitleShowMapView()"><i class="fal fa-arrow-circle-left"></i> Cerrar mapa</div>
        <TopToolBarPaginator
          :key="paginatorKey"
          :totalItems="totalItems"
          :pageSize="PAGE_SIZE"
          :name="'Tareas por página:'"
          :pageSizes="[25, 50 , 75, 100]"
          @sizeChange="changeSize"
          @pageChange="loadPage"
          v-b-tooltip.hover.left="'Total de registros: ' + totalItems"
          style="z-index: 0"
          :isCursorBased="true"/>
      </div>

      <!-- DATA TABLE -->
      <div v-if="!mapViewActive" class="table-container">
        <table class="data-table table table-hover">
          <thead>
            <tr>
              <template v-for="(item, index) in columns">
                <th v-if="index === 0" :key="index" class="th-selector"
                  :class="{
                    'has-permission-to-read': hasPermissionToReadFills,
                    'has-permission-to-edit': hasPermissionToEditFills,
                    '--history-activated': historyActive,
                  }"
                >
                  <div class="th-selector-content">
                    <b-form-checkbox v-show="!historyActive" size="lg" v-model="toggleAll" @change="toggleAllItemsSelection($event)"
                      :disabled="historyActive">{{ item.label }}</b-form-checkbox>
                  </div>
                </th>
                <th :key="index" v-else-if="isColumnVisible(item.name)"
                  :title="item.name + (item.label && item.label.length > 35 ? `\n\n${item.label}` : '')"
                  :class="{
                    'is-first-column': index === 1,
                    'is-ident': item.ident,
                    'has-permission-to-read': hasPermissionToReadFills,
                    'has-permission-to-edit': hasPermissionToEditFills,
                    'has-permission-to-reset': hasPermissionToResetFills,
                    '--history-activated': historyActive,
                    'computed-field': item.isComputed()
                  }"
                >
                  <div>
                    <span v-if="item.icon"><i :class="[item.icon]"></i>&nbsp;</span>
                    <span v-if="item.number" class="number">{{ item.number }}</span>
                    <!-- To show both values final and computed -->
                    <template v-if="item.isComputed()">
                      <span class="computed-field__label">
                        <p class="computed-field__label__label">{{ item.label }}</p>
                        <span>
                          <p class="computed-field__label__final">Accepted</p>
                          <p class="computed-field__label__computed">Computed</p>
                        </span>
                      </span>
                    </template>
                    <template v-else>
                      <span>
                        {{ item.label }}
                      </span>
                    </template>
                  </div>
                </th>
              </template>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="item in historyActive ? itemsHistory : items"
              :key="item.id"
              :class="{
                'selected': selectedItems.includes(item._id),
                '--history-activated': historyActive,
                '--history-disabled': !historyActive || !validateHistoryItem(item),
                '--history-selected': historyActive && selectedHistoryItem == item._id && hasPermissionToResetFills,
              }"
              @dblclick.exact="() => openFillInTypist(item)"
              @click.exact="() => handleOnClickItem(item)"
            >
              <template v-for="(value, name, index) in item">
                <template v-if="index === 0">
                  <th :key="index" class="th-selector"
                    :class="{
                      '--history-activated': historyActive,
                      'has-permission-to-read': hasPermissionToReadFills,
                      'has-permission-to-reset': hasPermissionToResetFills
                    }"
                  >
                    <div class="th-selector-content">
                      <template v-if="historyActive">
                        <template v-if="hasPermissionToResetFills">
                          <b-form-radio
                            :id="'history-item-' + item._id" size="lg"
                            name="history-item-to-reset"
                            :value="item._id"
                            v-model="selectedHistoryItem"
                            :disabled="!historyActive || !validateHistoryItem(item)"
                          ></b-form-radio>
                          <div class="d-flex flex-row align-items-center justify-content-center p-1">
                            <b-button
                              v-show="selectedHistoryItem == item._id"
                              class="shadow-sm rounded-lg" variant="warning" size="sm"
                              :title="$t('fillgrid.modals.resetHistory.reset')"
                              :disabled="!historyActive"
                              @click.stop="showResetHistoryModal = true"
                            ><i class="far fa-undo fa-sm"></i></b-button>
                          </div>
                        </template>
                      </template>
                      <template v-else>
                        <b-form-checkbox
                          :id="'chk-item-' + item._id" size="lg"
                          :value="item._id"
                          v-model="selectedItems"
                          :disabled="historyActive"
                          @click.native.stop
                        ></b-form-checkbox>
                        <div class="d-flex flex-row align-items-center justify-content-center p-1">
                          <b-button
                            v-if="hasPermissionToEditFills && !historyActive"
                            class="shadow-sm rounded-lg mr-1" variant="light" size="sm"
                            title="Ver detalle"
                            @click.stop.exact="() => openFillInTypist(item)"
                          >
                            <i v-if="isEnableOrWebEnableTemplate" class="fal fa-pen"></i>
                            <i v-else class="fal fa-file-search"></i>
                          </b-button>
                          <b-button
                            v-if="hasPermissionToEditFills && !historyActive"
                            class="shadow-sm rounded-lg" variant="light" size="sm"
                            title="Mostrar histórico"
                            @click.stop.exact="() => showFillHistory(item)"
                          >
                            <i class="fal fa-history"></i>
                          </b-button>
                        </div>
                      </template>
                    </div>
                    <div class="priority" v-if="item._priority" :style="{ 'background-color': item._priority }"></div>
                  </th>
                </template>
                <template v-else>
                  <td :key="index" v-if="columns[index] && isColumnVisible(name, columns[index])"
                    :class="{
                      'is-first-column': index === 1,
                      'is-ident': columns[index]?.ident,
                      'has-permission-to-edit': hasPermissionToEditFills,
                      '--history-activated': historyActive,
                      'has-permission-to-read': hasPermissionToReadFills,
                      'has-permission-to-reset': hasPermissionToResetFills,
                      'computed-field': columns[index].isComputed()
                      }"
                  >
                    <div v-if="columns[index] && columns[index].type === QUESTION_TYPES.PHOTO" class="special-field photo" :class="{ displayImages }">
                      <span v-if="!displayImages">
                        <i
                          :id="`show-image-${item._id}-${index}`"
                          class="fal fa-camera-alt"
                          :class="{ 'missing': !value }"
                          :title="value ? `Ver detalle` : 'Sin fotografía'"
                          :disabled="!value"
                          @click="() => {
                            if (value) {
                              showMediaViewer(
                                QUESTION_TYPES.PHOTO,
                                getPhotoPayload(value, item, index),
                                columns[index].name
                              )
                            }
                          }" />
                        <!-- Image popover-->
                        <b-popover
                          :target="`show-image-${item._id}-${index}`"
                          triggers="hover"
                          placement="right"
                          custom-class="popover-image-preview"
                          @show="fetchPhotoPreview(value, columns[index].name)"
                        >
                          <img v-if="value && value.url" :src="value.url">
                          <i v-else class="far fa-spinner-third fa-spin"></i>
                        </b-popover>
                        <!-- Image info popover-->
                        <b-popover
                          :target="`show-image-${item._id}-${index}`"
                          triggers="hover"
                          placement="left"
                          custom-class="popover-image-preview"
                        >
                          <div class="image-displayed__details">
                            <!-- Datetime image -->
                            <div v-if="value && value.date" class="image-displayed__datetime">
                              <p class="m-0 font-weight-bold">Fecha y hora</p>
                              <p class="m-0">{{getFillColumnDateTimeFormat(value.date, true)}}</p>
                            </div>
                            <!-- Location image -->
                            <div v-if="value && value.location" class="image-displayed__location">
                              <p class="m-0 mt-2 font-weight-bold">Ubicación</p>
                              <p class="m-0">Latitud: {{value.location.latitude}}</p>
                              <p class="m-0">Longitud: {{value.location.longitude}}</p>
                              <p class="m-0">Altitud: {{value.location.altitude}}</p>
                            </div>
                          </div>
                        </b-popover>
                      </span>
                      <div v-else class="image-displayed__content">
                        <div v-if="!value" class="image-displayed__details">
                          <p class="m-0 text-center">Sin fotografía</p>
                        </div>
                        <!-- Image info-->
                        <div v-else class="image-displayed__details">
                          <!-- Datetime image -->
                          <div v-if="value && value.date" class="image-displayed__datetime">
                            <p class="m-0 font-weight-bold">Fecha y hora</p>
                            <p class="m-0">{{getFillColumnDateTimeFormat(value.date, true)}}</p>
                          </div>
                          <!-- Location image -->
                          <div v-if="value && value.location" class="image-displayed__location">
                            <p class="m-0 mt-2 font-weight-bold">Ubicación</p>
                            <p class="m-0">Latitud: {{value.location.latitude}}</p>
                            <p class="m-0">Longitud: {{value.location.longitude}}</p>
                            <p class="m-0">Altitud: {{value.location.altitude}}</p>
                          </div>
                        </div>
                        <div class="image-displayed__image">
                          <LazyImage
                            v-if="value && value.name"
                            v-model="value.url"
                            :attachment="value.name"
                            :template="templateId"
                            :question="value.column"
                            @open-image="showMediaViewer(
                                QUESTION_TYPES.PHOTO,
                                getPhotoPayload(value, item, index),
                                columns[index].name)"
                          />
                          <div v-else class="d-flex justify-content-center align-items-center h-100">
                            <i
                              :id="`show-image-${item._id}-${index}-missing`"
                              class="fal fa-camera-alt missing"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Location fields/columns -->
                    <div
                      v-else-if="columns[index] && columns[index].type === QUESTION_TYPES.LOCATION"
                      class="special-field"
                      v-b-tooltip.hover.left.html="value ? `<b>Ubicación</b><br>Latitud ${value.latitude}<br>Longitud ${value.longitude}<br>Altitud ${value.altitude}` : ''"
                    >
                      <!-- Location fullfilled -->
                      <i
                        v-if="value && (value.latitude + value.longitude)"
                        class="fal fa-map-marker-check"
                        title="Ver ubicación"
                        @click="
                          showMediaViewer(
                            QUESTION_TYPES.LOCATION,
                            getLocationPayload(value, item, index),
                            columns[index].name
                          )
                        "
                      ></i>
                      <!-- Missing location -->
                      <i v-else class="fal fa-map-marker-question missing" title="Ubicación no proporcionada"></i>
                    </div>

                    <div v-else-if="columns[index] && columns[index].type === QUESTION_TYPES.AUDIO" class="special-field">
                      <i class="fal fa-volume-up" title="Ver detalle" v-if="value" @click="showMediaViewer(QUESTION_TYPES.AUDIO, value, columns[index].name)"></i>
                      <i class="fal fa-volume-up missing" title="Audio no proporcionado" v-else></i>
                    </div>

                    <div v-else-if="columns[index] && columns[index].type === QUESTION_TYPES.PDF" class="special-field">
                      <LazyPDF v-if="value && value.name" v-model="value.url" :attachment="value.name" :template="templateId" :question="value.column" @open-pdf="showMediaViewer(QUESTION_TYPES.PDF, value, columns[index].name)"/>
                      <i v-else class="fal fa-file-pdf missing" title="Documento no proporcionado"></i>
                    </div>

                    <div v-else-if="columns[index] && columns[index].type === QUESTION_TYPES.FILE" class="special-field">
                      <b-button v-if="value" variant="light" :disabled="value === downloadingFileItem" @click.stop="downloadFile(value, columns[index].name)">
                        <i v-show="value !== downloadingFileItem" class="fal fa-download" title="Descargar archivo"></i>
                        <i v-show="value === downloadingFileItem" class="fal fa-spinner-third fa-spin" title="Descargando"></i>
                      </b-button>
                      <i class="fal fa-download missing" title="Archivo no proporcionado" v-else></i>
                    </div>

                    <div v-else-if="value && columns[index] && columns[index].type === QUESTION_TYPES.SELECT && ['SIMPLE', 'MULTIPLE'].includes(columns[index].questionRef.display.type)">
                      {{ value.join(', ') }}
                    </div>

                    <div v-else-if="value && columns[index] && columns[index].type === QUESTION_TYPES.SELECT && columns[index].questionRef.display.type === 'PRIORITY'">
                      {{ value[0] }} <i class="fas fa-circle" :style="{ color: getFieldSelectPriorityValue(columns[index].questionRef.display.options, value[0]) }"></i>
                    </div>

                    <div v-else-if="value && columns[index] && columns[index].type === QUESTION_TYPES.DATE">
                      {{ getFillColumnDateFormat(value, columns[index].metadata, columns[index].questionRef.formatDate) }}
                    </div>

                    <div v-else-if="value && columns[index] && columns[index].type === QUESTION_TYPES.DATETIME">
                      {{ getFillColumnDateTimeFormat(value, columns[index].metadata, columns[index].questionRef.formatDate, columns[index].questionRef.formatTime) }}
                    </div>

                    <!-- Math formula with sealant questions -->
                    <div v-else-if="value && columns[index] && columns[index].isComputed()"
                      class="computed-field__content">
                      <template v-if="columns[index].type === QUESTION_TYPES.CURRENCY">
                        <p class="computed-field__final">{{ currencyFormat(value['final'], columns[index].questionRef.decimalMax) }}</p>
                        <p class="computed-field__computed">{{ currencyFormat(value['computed'], columns[index].questionRef.decimalMax) }}</p>
                      </template>
                      <template v-else-if="columns[index].type === QUESTION_TYPES.DECIMAL">
                        <p class="computed-field__final">{{ decimalFormat(value['final'], columns[index].questionRef.decimalMax, columns[index].questionRef.thousandsSeparator) }}</p>
                        <p class="computed-field__computed">{{ decimalFormat(value['computed'], columns[index].questionRef.decimalMax, columns[index].questionRef.thousandsSeparator) }}</p>
                      </template>
                      <template v-else-if="columns[index].type === QUESTION_TYPES.INTEGER">
                        <p class="computed-field__final">{{ integerFormat(value['final'], columns[index].questionRef.thousandsSeparator) }}</p>
                        <p class="computed-field__computed">{{ integerFormat(value['computed'], columns[index].questionRef.thousandsSeparator) }}</p>
                      </template>
                      <template v-else>
                        <!-- Text Question -->
                        <p class="computed-field__final">{{ value['final'] }}</p>
                        <p class="computed-field__computed">{{ value['computed'] }}</p>
                      </template>
                    </div>

                    <div v-else-if="value && columns[index] && columns[index].type === QUESTION_TYPES.CURRENCY">
                      {{ currencyFormat(value, columns[index].questionRef.decimalMax ) }}
                    </div>
                    <div v-else-if="value && columns[index] && columns[index].type === QUESTION_TYPES.DECIMAL">
                      {{ decimalFormat(value, columns[index].questionRef.decimalMax, columns[index].questionRef.thousandsSeparator) }}
                    </div>
                    <div v-else-if="value && columns[index] && columns[index].type === QUESTION_TYPES.INTEGER">
                      {{ integerFormat(value, columns[index].questionRef.thousandsSeparator) }}
                    </div>

                    <!-- Evidence video proto -->
                    <div v-else-if="value && typeof value === 'string' && value.startsWith('video:') && columns[index] && columns[index].type === QUESTION_TYPES.TEXT">
                      <DownloadVideoButton :value="value"/>
                    </div>

                    <div v-else :title="value && value.length && value.length > 40 ? value : ''">{{ value }}</div>
                  </td>
                </template>
              </template>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else class="map-container">
        <FillGridMap
          :tasks="items"
          :idents="idents"
          :idents-labels="identsLabels"
        />
      </div>
    </div>

    <!-- ASYNC TASKS MODAL -->
    <AsyncTaskFillgrid
      :userId="userId"
      :totalFills="totalItems"
      :modalId="asyncModalId"
      :templateId="parseInt(templateId)"
      :templateName="templateTitle"
      :filters="filters"
      :searches="searches"
      :searchIdSelected="searchIdSelected"
      :creatingSearch="creatingSearch"
      :searchError="searchError"
      :existTaskInProcess="existTaskInProcess"
      :attachmentColumns="attachmentColumns"
      :permissionToSelectAttahments="hasPermissionToDownloadAttachments"
      :variablesFillsIdent="variablesFillsIdent"
      @create-search="saveSearch"
      @waiting-search="setCreatingSearch"
      @update-search="setSearchIdSelected"
      @close="showAsyncTaskModalEvent(false)"
      @check-view-changes="updateAutoSaveView(true)" />
    <!-- ASYNC TASK FEEDBACK TOAST-->
    <div v-if="asyncTaskToast" class="toast async-task-toast"
      :class="{ show: asyncTaskToast, success: asyncTaskSuccess }"
      role="alert" aria-live="assertive" aria-atomic="true">
      <div class="toast-header">
        <strong class="mr-auto">Descarga de <em>Mis Tareas</em> creada.</strong>
        <button type="button" class="ml-2 mb-1 close"
          @click="hideAsyncTaskToast"
          data-dismiss="toast" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="toast-body">
          <p class="task-id"><span>ID:</span> {{ asyncTaskDetails.id }}</p>
          <p class="task-name"><span>Template:</span> {{ `${asyncTaskDetails.template.label} [v${asyncTaskDetails.template.version}]` }}</p>
          <p class="task-name"><span>Fecha:</span> {{ asyncTaskDetails.getLocalCreationDate() }}</p>
          <p class="small task-request-id"><span>Request Id:</span> {{ asyncTaskDetails.process.requestId }}</p>
      </div>
    </div>

    <!-- ASSIGN USER MODAL -->
    <b-modal id="assign-user-modal" title="Asignación de tareas">
      <p>Selecciona un usuario para asignar las tareas seleccionadas</p>
      <b-form-input id="user-to-assign" v-model="assignationUser" placeholder="Ingresa un usuario..." size="lg"
        list="active-users-list" class="shadow-sm" :state="validActiveUserForAssignation" trim></b-form-input>
      <b-form-invalid-feedback id="user-to-assign-feedback">
        El nombre de usuario no existe o este está dado de baja. Puedes intentar con un usuario diferente.
      </b-form-invalid-feedback>
      <br>
      <b-form-checkbox size="lg" v-model="activeAssignRows">Active la casilla para habilitar la opción de asignar</b-form-checkbox>
      <template v-slot:modal-footer="{ cancel }">
        <b-button variant="primary" @click="saveAssignationUser" :disabled="!assignationUser || !activeAssignRows || loadingData || !validActiveUserForAssignation">
          Asignar
        </b-button>
        <b-button variant="secondary" @click="cancel()">
          Cancelar
        </b-button>
      </template>
    </b-modal>

    <!-- DELETE MODAL -->
    <b-modal id="delete-rows-modal" title="Eliminar registros">
      <h5>Los registros seleccionados serán borrados de forma permanente.</h5>
      <b-form-checkbox size="lg" v-model="activeDeleteRows">Active la casilla para habilitar la opción de eliminar</b-form-checkbox>
      <template v-slot:modal-footer="{ cancel }">
        <b-button variant="danger" @click="deleteRows" :disabled="!activeDeleteRows">
          Eliminar registros
        </b-button>
        <b-button variant="secondary" @click="cancel()">
          Cancelar
        </b-button>
      </template>
    </b-modal>

    <!-- CHANGE STATUS ROWS MODAL -->
    <b-modal id="change-status-rows-modal" title="Generar PDF">
      <h5>A los registros seleccionados se les generará su PDF</h5>
      <p>Importante: una vez generado el PDF esta operación no se puede modificar.</p>
      <b-form-checkbox size="lg" v-model="activeChangeStatusRows">Active la casilla para confirmar y habilitar la opción de generar PDF</b-form-checkbox>
      <template v-slot:modal-footer="{ cancel }">
        <b-button variant="primary" @click="changeStatusRows" :disabled="!activeChangeStatusRows">
          Generar PDFs
        </b-button>
        <b-button variant="secondary" @click="cancel()">
          Cancelar
        </b-button>
      </template>
    </b-modal>

    <!-- UPDATES MULTIPLE MODAL -->
    <b-modal content-class="updates-multiple-modal" id="updates-multiple-modal" :title="updatesMode === FILL_UPDATE_MODE.MODIFY ? 'Modificar' : 'Gestionar'" size="lg" no-close-on-esc no-close-on-backdrop>
      <h5 class="text-left">Agregue los campos que desee actualizar para todos los registros seleccionados</h5>
      <p v-if="allDisableSelectedItems" class="px-2 bg-danger text-white rounded">Ninguna de las tareas seleccionadas pueden ser modificar debido a su status.</p>
      <p v-else-if="existsDisableSelectedItems" class="px-2 bg-warning rounded">Existen tareas seleccionadas que no serán modificas debido a su status.</p>
      <div class="container">
        <div class="fields" v-if="fieldsListToUpdate.length">
          <hr>
          <div class="input-field" v-for="(item, index) in fieldsListToUpdate" :key="index">
            <div class="remove" title="Eliminar campo" @click="deleteFieldToUpdate(index)"><i class="fas fa-times-circle"></i></div>
            <InputFormValue :field="item" :index="index" />
          </div>
        </div>

        <hr style="margin-top: 0">

        <b-form-select v-show="isRemainingColumnsToModifyOrManage" v-model="fieldToUpdate" size="lg" class="shadow-sm custom-field-selector"
          :disabled="allDisableSelectedItems"
          @change="addFieldToUpdate"
        >
          <template slot="first">
            <option value="">+ Campo</option>
          </template>
          <option v-for="(column, index) in columns" :key="index"
            :value="column.name"
            v-show="validateEditableColumn(column)"
          >
            {{
              (column.label && column.label.length > 75)
              ? column.label.substring(0,75) + '...'
              : column.label
            }}
          </option>
        </b-form-select>

        <div v-if="fieldsListToUpdate.length">
          <br>
          <b-form-checkbox size="lg" v-model="activeUpdateMultipleRows">Active la casilla para habilitar la opción de actualizar</b-form-checkbox>
        </div>
      </div>

      <template v-slot:modal-footer="{ cancel }">
        <b-button variant="primary" @click="applyUpdatesMultiple" :disabled="loadingData || !fieldsListToUpdate.length || !activeUpdateMultipleRows || allDisableSelectedItems">
          Aplicar cambios
        </b-button>
        <b-button variant="secondary" @click="cancel()">
          Cancelar
        </b-button>
      </template>

      <LoadingMask :active="loadingData"/>
    </b-modal>

    <!-- DOWNLOAD FILES MODAL -->
    <b-modal id="download-files-modal" title="Descargar archivos">
      <h5 style="margin-bottom: 15px">Elige los archivos que serán descargados de los registros seleccionados.</h5>
      <b-form-checkbox size="md">Campo 1</b-form-checkbox>
      <b-form-checkbox size="md">Campo 2</b-form-checkbox>
      <b-form-checkbox size="md">Campo 3</b-form-checkbox>
      <b-form-checkbox size="md">Campo 4</b-form-checkbox>
      <b-form-checkbox size="md">Campo 5</b-form-checkbox>

      <hr>

      <b-form-group label="Ingresa un correo electrónico">
        <b-form-input
          v-model.trim="downloadEmail"
          type="email"
          placeholder="Correo electrónico"
        ></b-form-input>
      </b-form-group>

      <template v-slot:modal-footer="{ cancel }">
        <b-button variant="primary" @click="downloadFiles" :disabled="!downloadEmail">
          Enviar liga de descarga
        </b-button>
        <b-button variant="secondary" @click="cancel()">
          Cancelar
        </b-button>
      </template>
    </b-modal>

    <!-- MEDIA VIEWER -->
    <b-modal id="media-viewer-modal" title="Visualizador" modal-class="modal-fullscreen" hide-footer>
      <MediaPreview :type="currentMediaTypeDisplayed" :src="currentMediaSourceDisplayed" />
    </b-modal>

    <b-modal
    id="modalIntegration"
    v-model="integrationModel"
    size="xl"
    no-close-on-esc
    hide-footer
    hide-header
    scrollable
    >
      <IntegrationTask
       :key="integrationTaskModalKey"
       :modalId="integrationTaskModalId"
       :template="Number(templateId)"
       :requiredFields="requiredColumns"
       :listNormalizers="listNormalizers"
       :is-list-normalizer="isGetListNormalizer"
       :columns="columns"
       @reset-component="resetIntegrationTaskModal"
       @on-finish-integration="onFinishIntegrationCloseModal"
       @send-notification="displayIntegrationTaskNotification"
       @reload-normalizers="reloadNormalizers">
      </IntegrationTask>
    </b-modal>

    <!-- Reset modal -->
    <b-modal
      id="reset-history-item-modal"
      v-model="showResetHistoryModal"
      :title="$t('fillgrid.modals.resetHistory.title')"
    >
      <b-alert :show="!enabledHistoryItemToReset">
        <i class="fa fa-info-circle"></i> {{ $t('fillgrid.modals.resetHistory.warning') }}
      </b-alert>
      <p>{{ $t('fillgrid.modals.resetHistory.description') }}</p>
      <div class="reset-history-item-modal__inputs">
        <div v-for="(item, index) in selectedResetHistoryDates" :key="`date-${index}`" class="reset-history-item-modal__inputs__item">
          <span
            class="reset-history-item-modal__inputs__item__remove-date" :title="$t('fillgrid.modals.resetHistory.removeField')"
            @click="() => removeResetHistoryDate(item)"><i class="fas fa-times-circle fa-lg"></i></span>
          <InputFormValue :field="item" :index="index"/>
        </div>
        <div class="reset-history-item-modal__select-date">
          <b-form-select
            v-show="resetHistoryDatesOptions.length"
            v-model="defaultResetHistoryDate"
            :options="resetHistoryDatesOptions"
            :disabled="!enabledHistoryItemToReset"
            @change="onChangeHistoryDate"
          >
            <template slot="first">
              <option value="" disabled>+ {{ $t('fillgrid.modals.resetHistory.addField') }}</option>
            </template>
          </b-form-select>
        </div>
      </div>
      <b-form-checkbox v-model="activeResetHistoryItem" required :disabled="!enabledHistoryItemToReset">
        {{ $t('fillgrid.modals.resetHistory.confirmAction') }}
      </b-form-checkbox>
      <template v-slot:modal-footer="{ cancel, ok }">
        <b-button variant="light" @click="() => cancelResetHistoryItem(cancel)">
          {{ $t('common.cancel') }}
        </b-button>
        <b-button
          :disabled="!activeResetHistoryItem || loadingData || !enabledHistoryItemToReset"
          variant="warning"
          @click="() => resetHistoryItem(ok)"
        >
          {{ $t('fillgrid.modals.resetHistory.reset') }}
        </b-button>
      </template>
      <loading-mask :active="loadingData"/>
    </b-modal>

    <!-- LOADING MASK -->
    <div class="loading-mask" v-show="loadingData || downloadingData">
      <i class="far fa-spinner-third fa-spin"></i>
    </div>

    <a style="display: none;" ref="fileDownload"></a>
    <a style="display: none;" ref="csvFillsDownload"></a>
  </div>
  <NotAllowedView v-else
    :errorCode="NOT_ALLOWED_VIEW.MISSING_PERMISSIONS.code"
    :description="NOT_ALLOWED_VIEW.MISSING_PERMISSIONS.description"
  >
  </NotAllowedView>
</template>

<script lang="ts">
import { Component, Provide, Vue } from 'vue-property-decorator'
import FillgridFiltersComponent from '@/components/fillgrid/fillgrid-filters.vue'
import FillgridViews from '@/components/fillgrid/fillgrid-views.vue'
import MediaPreview from '@/components/fillgrid/media-preview.vue'
import FillGridMap from '@/components/fillgrid/FillGridMap.vue'
import FillGridMapAside from '@/components/fillgrid/FillGridMapAside.vue'
import InputFormValue from '@/components/forms/input-form-value.vue'
import TopToolBarPaginator from '@/components/generic/TopToolBarPaginator.vue'
import fillgridService from '@/services/FillgridService'
import cookiesService, { BM_COOKIES } from '@/services/support/CookiesService'
import { AllowedFillResetStatuses, BMP_USER, EditableFillgridColumnDates, FillgridColumn, FillgridFilters, FillgridSearchFilters, TemplateQuestionsTypes } from '@/types/Fillgrid'
import { CursorRequest, PageRequest } from '@/types/Support'
import userInfoStore from '@/store/userInfo'
import config from '@/config'
import LoadingMask from '@/components/generic/LoadingMask.vue'
import moment from 'moment'
import { PROCESS_STATUS, UNDEFINED_ENTITY_ID, UserCatalogFilters } from '@/types/Catalogs'
import { PermissionNames, RoleNames } from '@/types/Auth'
import AsyncTaskFillgrid from '@/components/fillgrid/AsyncTaskFillgrid.vue'
import { AsyncTask } from '@/types/catalogs/AsyncTask'
import { CustomSearch, SearchOrigin } from '@/types/catalogs/CustomSearch'
import { APIErrorFormat } from '@/types/Errors'
import { NUMBER } from '@/types/GeneralConstants'
import LogService from '@/services/support/LogService'
import { AttachmentObject, SelectableAttachments, VariableFill } from '@/types/catalogs/Attachment'
import NotAllowedView from '@/components/permissions/NotAllowedView.vue'
import { NOT_ALLOWED_VIEW } from '@/types/viewAccess/AccessFailed'
import localStorageUser from '@/store/localStoreUser'
import { CONFIGURATION_KEY, ConfigurationResponse } from '@/types/Configuration'
import Normalizer from '@/types/Normalizer'
import { Template } from '@/types/Templates'

const MAX_SIMULTANEUS_REQUESTS = 10
const TIME_SIMULTANEUS_REQUESTS_WAIT = 3000
const URL_SEARCH_PARAMS_MAX_LENGTH = 2048

// eslint-disable-next-line
enum FILL_UPDATE_MODE {
  // eslint-disable-next-line
  MODIFY = 'modificar',
  // eslint-disable-next-line
  MANAGE = 'gestionar'
}

@Component({
  components: {
    IntegrationTask: () => import('@/components/fillgrid/IntegrationTask.vue'),
    FillgridFiltersComponent,
    FillgridViews,
    InputFormValue,
    TopToolBarPaginator,
    LoadingMask,
    MediaPreview,
    FillGridMap,
    FillGridMapAside,
    AsyncTaskFillgrid,
    NotAllowedView,
    DownloadVideoButton: () => import('@/components/fillgrid/DownloadVideoButton.vue'),
    LazyImage: () => import('@/components/fillgrid/LazyImage.vue'),
    LazyPDF: () => import('@/components/fillgrid/LazyPDF.vue')
  }
})
export default class Fillgrid extends Vue {
  template: Template | null = null
  templateId: number = UNDEFINED_ENTITY_ID
  variablesFillsIdent: Array<VariableFill> = []

  QUESTION_TYPES = TemplateQuestionsTypes
  PAGE_SIZE = 25
  PAGE_SEARCHES_SIZE = 100
  FILL_UPDATE_MODE = FILL_UPDATE_MODE
  ORIGIN_PARAM = 'fillgrid'
  NOT_ALLOWED_VIEW = NOT_ALLOWED_VIEW
  DISABLE_FILL_STATUS = ['FNL', 'GEO', 'RVG', 'RCH', 'MRK']

  cursorRequest = new CursorRequest<FillgridFilters>(this.PAGE_SIZE, true)
  filters: FillgridFilters = new FillgridFilters()
  items: Record<string, any>[] = []
  itemsHistory: Record<string, any>[] = []
  cursorHistory = { 1: '' } as any
  pagesLoaded = {} as any
  totalPages = 0
  totalItems = 0
  paginatorKey = 0
  selectedItems: string[] = []

  selectedFillHistoryName: string | null = null
  selectedHistoryItem: number | null = null
  showResetHistoryModal: boolean = false
  resetHistoryDates = [
    EditableFillgridColumnDates.ACTIVATION,
    EditableFillgridColumnDates.EXPIRATION
  ]
  defaultResetHistoryDate = ''
  selectedResetHistoryDates: any[] = []
  activeResetHistoryItem: boolean = false

  idents: string[] = []
  identsLabels: string[] = []
  toggleAll = false
  loadingData = false
  leftSidebarCollapsed = false
  columnsToShow: any[] = []
  viewSelected = 0
  displayImages = false
  downloadingFileItem = ''
  downloadingData = false
  downloadCurrentPage = 1

  columns: FillgridColumn[] = []
  noVisibleColumns: string[] = [
    '_priority',
    '_visitedLocation',
    '_fillLocation',
    '_last'
  ]
  users = [] as string[]
  activeUsersNames: string[] = []

  mediaPreviewActive = false
  currentMediaTypeDisplayed = ''
  currentMediaSourceDisplayed: any = {}

  /** Update operations */
  assignationUser = ''
  activeDeleteRows = false
  activeAssignRows = false
  activeUpdateMultipleRows = false
  activeChangeStatusRows = false
  fieldToUpdate = ''
  fieldsListToUpdate: any[] = []
  downloadEmail = ''
  /** Attributes to manage async tasks */
  asyncModalId = 'downloadFillsModal'
  asyncTaskToast = false
  asyncTaskSuccess?: boolean = undefined
  asyncTaskError?: boolean = undefined
  asyncTaskDetails: AsyncTask = AsyncTask.getInstance()
  existTaskInProcess: boolean = false
  attachmentColumns: AttachmentObject[] = []
  selectableAttachments: TemplateQuestionsTypes[] = SelectableAttachments
  // Search Filter
  searches: CustomSearch[] = []
  searchIdSelected: number = UNDEFINED_ENTITY_ID
  creatingSearch: boolean = false
  searchUpdated: number = 0 // 0: init, 1: success, 2: error
  searchError: String = ''
  isUpdating: boolean = false

  autoSaveView: boolean = false

  historyActive = false
  updatesMode: FILL_UPDATE_MODE = FILL_UPDATE_MODE.MODIFY // modificar, gestionar

  /** Integration task */
  integrationModel= false
  integrationTaskModalId = 'integrationTaskModal'
  integrationTaskModalKey = 0

  /** Normalization task */
  listNormalizers: Array<Normalizer> = []
  isGetListNormalizer: boolean = false

  /** Map View */
  mapViewActive: boolean = false
  mapViewVisible: boolean = false

  temporaryCustomSearchId: number | undefined = undefined
  doRequestsByFTS = false
  ftsDefaultProbabilityPercentage: number = 50
  ftsProbabilityPercentage: number = this.ftsDefaultProbabilityPercentage
  apiConfiguration: ConfigurationResponse = { configuration: [] }

  async beforeCreate () {
    try {
      this.apiConfiguration = await fillgridService.getApiConfiguration()
      this.ftsProbabilityPercentage = this.getFtsProbabilityPercentage()
    } catch (error) {
      LogService.error('Error fetching API configuration: ' + error)
    }
  }

  async created () {
    this.templateId = Number.parseInt(this.$route.params.id)
    if (this.templateId === -1) {
      return
    }

    const template = await fillgridService.getTemplateById(this.templateId)
    this.template = template
    this.idents = template.idents || []
    const columns = fillgridService.getTemplateColumns(template, template.idents)
    this.idents.forEach(name => {
      const col = columns.find(it => it.name === name)
      this.identsLabels.push(col ? col.label : '')
    })

    const columnsWithoutBlockedQuestions = columns.filter(column => !this.template?.blockedQuestions?.includes(column.name))
    this.columns = Object.freeze(columnsWithoutBlockedQuestions) as any
    this.noVisibleColumns = [...this.noVisibleColumns, ...this.template.blockedQuestions]

    this.idents.forEach((ident, index) => {
      this.variablesFillsIdent.push({ variableId: `ident${index}`, variableValue: template.idents[index] })
    })

    this.getAllUsers()
    this.getAllSearches()
  }

  isDisableFillStatus (status: any): boolean {
    return this.DISABLE_FILL_STATUS.includes(status)
  }

  get templateTitle (): string {
    return this.template ? `${this.template.label} [v${this.template.version}]` : 'No template'
  }

  get userId (): number {
    return userInfoStore.userInfo.id
  }

  getAttachmentsFromColumns (columns: any[], columnsToShow: string[]) : void {
    let attachmentColumns = columns.filter((col) => this.selectableAttachments.includes(col.type))
    if (columnsToShow.length) {
      attachmentColumns = attachmentColumns.filter((column) => columnsToShow.includes(column.name))
    }
    this.attachmentColumns = attachmentColumns.map((column) => {
      return {
        name: column.name,
        label: column.label,
        type: column.type
      } as AttachmentObject
    })
  }

  /* Permissions */

  get fillsViewPermission () {
    return userInfoStore.hasPermission(PermissionNames.FILLS_VIEW)
  }

  get hasPermissionToReadFills () {
    return userInfoStore.hasPermission(PermissionNames.FILLS_READ)
  }

  get hasPermissionToEditFills () {
    return userInfoStore.hasPermission(PermissionNames.FILLS_EDIT)
  }

  get createFillsPermission () {
    return userInfoStore.hasPermission(PermissionNames.FILLS_CREATE) &&
      userInfoStore.hasPermission(PermissionNames.FILLS_EDIT)
  }

  get normalizationPermission () {
    return userInfoStore.hasPermission(PermissionNames.NORMALIZERS_READ)
  }

  get hasTypistPermission () {
    return userInfoStore.hasPermission(PermissionNames.TYPIST_VIEW)
  }

  get updateFillsPermission () {
    return userInfoStore.userInfo.role.permissions.some(it => it.name === PermissionNames.FILLS_UPDATE)
  }

  /**
   * Valdate if the user has all the permissions to manage fills with
   * quick edit fields
   */
  get hasPermissionToQuickEdit (): boolean {
    const permissions = [
      PermissionNames.FILLS_UPDATE,
      PermissionNames.FILLS_QUICKEDIT
    ]
    return userInfoStore.hasPermissions(permissions)
  }

  /**
   * Validate if there is some quick edit field in the template to manage
   */
  get isThereSomeQuickEditField (): boolean {
    return this.columns.some((column: FillgridColumn) => this.isQuickEditField(column))
  }

  /**
   * Validate if there is some PDF in the template
   */
  get isThereSomePdfField (): boolean {
    return this.columns.some((column: FillgridColumn) => this.isPdfField(column))
  }

  /**
   * Validate if there is some field remaining to select to modify or manage
   */
  get isRemainingColumnsToModifyOrManage (): boolean {
    return this.updatesMode === FILL_UPDATE_MODE.MODIFY
      ? this.columns.some((column: FillgridColumn) => this.isEditableColumn(column))
      : this.columns.some((column: FillgridColumn) => this.isQuickEditEditableColumn(column))
  }

  get deleteFillsPermission () {
    return userInfoStore.userInfo.role.permissions.some(it => it.name === PermissionNames.FILLS_DELETE)
  }

  get pdfFillsPermission () {
    return userInfoStore.hasPermission(PermissionNames.FILLS_PDF)
  }

  get isEnableTemplate () {
    return this.template?.enabled
  }

  get isWebEnableTemplate () {
    return this.template?.webEnabled
  }

  /**
   * Validate if a template is enable or webEnable.
   * But this is always true for users with role 'operationsAdmin'
   */
  get isEnableOrWebEnableTemplate () {
    return userInfoStore.hasRole(RoleNames.OPERATIONS_ADMIN) || this.isEnableTemplate || this.isWebEnableTemplate
  }

  /**
   * Validates if the user has all the permissions to can modify fills
   */
  get modifyFillsPermission () {
    return this.integrateFillsPermission && userInfoStore.hasPermission(PermissionNames.FILLS_MODIFY) && this.isEnableOrWebEnableTemplate
  }

  get integrateFillsPermission () {
    return userInfoStore.hasPermission(PermissionNames.FILLS_INTEGRATE)
  }

  get assignFillsPermission () {
    return userInfoStore.hasPermission(PermissionNames.FILLS_ASSIGNMENT)
  }

  get readAttachmentsPermission () {
    return userInfoStore.hasPermission(PermissionNames.ATTACHMENTS_READ)
  }

  get integrationTaskPermissions () {
    const requiredPermissions = [
      PermissionNames.INTEGRATION_CREATE,
      PermissionNames.INTEGRATION_UPDATE
    ]
    const minimunPermissions = [
      PermissionNames.FILLS_INTEGRATE,
      PermissionNames.FILLS_ASSIGNMENT
    ]
    return userInfoStore.hasPermissions(requiredPermissions) &&
      minimunPermissions.some(permission => userInfoStore.hasPermission(permission)) && this.isEnableOrWebEnableTemplate
  }

  get isTemplateWithLocation () {
    return this.template && (this.template.fillLocation || this.template.visitedLocation)
  }

  get requiredColumns () {
    return this.columns
      .filter(column => column.ident || column.questionRef?.requiredForIntegration)
      .map(fieldRequired => { return { name: fieldRequired.name, label: fieldRequired.label } })
  }

  get hasPermissionToDownloadAttachments () {
    return userInfoStore.hasPermission(PermissionNames.DATAFEEDATTACH_CREATE)
  }

  /** Return the asyn task modal id */
  get downloadFillsModalId () {
    return '#' + this.asyncModalId
  }

  get validActiveUserForAssignation (): boolean | null {
    if (!this.assignationUser) {
      return null
    }
    return this.assignationUser.length > 0 && this.activeUsersNames.includes(this.assignationUser)
  }

  get hasPermissionToResetFills () {
    return userInfoStore.hasPermission(PermissionNames.FILLS_RESET)
  }

  updateAutoSaveView (value: boolean): void {
    this.autoSaveView = value
  }

  /**
   * Manage the event to show the async task modal
   * @param value true to show, false to hide
  */
  showAsyncTaskModalEvent (value: boolean) {
    const modal = document.getElementById(this.asyncModalId)
    if (value) {
      this.setExistTaskInProcess(this.isSomeTaskInProcess())
      modal!.style.display = 'block'
    } else {
      modal!.style.display = 'none'
    }
  }

  onFinishIntegrationCloseModal () {
    const modal = document.getElementById(this.integrationTaskModalId)
    if (modal) {
      modal.style.display = 'none'
      modal.attributes.removeNamedItem('aria-modal')
      modal.setAttribute('aria-hidden', 'true')
      this.resetIntegrationTaskModal()
    }
  }

  displayIntegrationTaskNotification (integrationTask: AsyncTask) {
    this.showIntegrationToast(
      'Integración iniciada',
      integrationTask.id,
      integrationTask.name,
      integrationTask.updateDate,
      integrationTask.process.requestId)
  }

  showIntegrationToast (title: string, id: number, source: string, date: string, requestId: string) {
    const dateOpts: Intl.DateTimeFormatOptions = { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' }
    const dateFormat = Intl.DateTimeFormat('es-MX', dateOpts).format(new Date(`${date}Z`))
    const h = this.$createElement
    const node = h(
      'div', { class: ['d-flex', 'flex-column', 'p-0'] }, [
        h('p', { class: 'm-0' }, [
          h('span', { class: ['font-weight-bold', 'mr-1'] }, `ID:`), `${id}`
        ]),
        h('p', { class: 'm-0' }, [
          h('span', { class: ['font-weight-bold', 'mr-1'] }, `Archivo:`), source
        ]),
        h('p', { class: 'm-0' }, [
          h('span', { class: ['font-weight-bold', 'mr-1'] }, `Fecha:`), dateFormat
        ]),
        h('p', { class: 'text small m-0' }, [
          h('span', { class: ['font-weight-bold', 'mr-1'] }, `Request:`), requestId
        ])
      ])
    this.$bvToast.toast([node], {
      title: `${title}. [Integración]`,
      variant: 'success',
      autoHideDelay: 7500,
      solid: true
    })
  }

  /**
   * Manage the event to show the async task toast whe one was created
   * @param task object returned when the task was created
  */
  showAsyncTaskToast (task: AsyncTask) {
    this.asyncTaskDetails = task
    this.asyncTaskToast = true
    this.asyncTaskSuccess = true
    setTimeout(() => {
      this.hideAsyncTaskToast()
    }, 6000)
  }

  /** Manage the event to hide the async task toast */
  hideAsyncTaskToast () {
    this.asyncTaskDetails = AsyncTask.getInstance()
    this.asyncTaskToast = false
    this.asyncTaskSuccess = undefined
    this.asyncTaskError = undefined
  }

  /**
   * Unshift a search into the current array.
   * This method will be called after a new async task is created with a new search.
   *
   * @param search a search to unshift from the async task modal
   */
  unshiftSearch (search: CustomSearch): void {
    this.searches.unshift(search)
  }

  /**
   * Create a page request configuration to get searches
   */
  preparePageSearchRequest (): PageRequest<FillgridSearchFilters> {
    let pageRequest = new PageRequest<FillgridSearchFilters>()
    pageRequest.size = this.PAGE_SEARCHES_SIZE
    pageRequest.sort = 'name'
    pageRequest.filters.origin = SearchOrigin.FILLGRID
    return pageRequest
  }

  /**
   * Get the searches based on a page request configuration
   *
   * @param pageRequest with config
   */
  async getSearches (pageRequest: PageRequest<FillgridSearchFilters>) {
    await fillgridService.getSearches(this.templateId, pageRequest)
      .then((response) => {
        this.searches.push(...response.results)
        // Continue loading searches if we haven't finished requesting all yet
        if (this.searches.length < response.total) {
          pageRequest.page++
          this.getSearches(pageRequest)
        }
      })
      .catch((error) => {
        LogService.log(`Error al obtener las búsquedas personalizadas: ${error}`)
      })
  }

  async getAllUsers () {
    let pageRequest = new PageRequest<UserCatalogFilters>()
    if (userInfoStore.userInfo.domain.name === 'root') {
      pageRequest.filters.domainId = cookiesService.get(config.domainIdCookieName)
    }
    try {
      // Load users from local storage
      const [allUsersNames, activeUsersNames] = await localStorageUser.getUsersNamesFromLocalStorage(pageRequest)
      this.updateAllUsersAndActiveUsers(allUsersNames, activeUsersNames)
    } catch (error) {
      LogService.error('Error fetching users from local storage: ' + error)
    }
  }

  /**
   * Call the method to get searches with an request configuration
   */
  async getAllSearches () {
    this.searches = []
    let pageRequest = this.preparePageSearchRequest()
    await this.getSearches(pageRequest)
  }

  /**
   * Set the current searchIdSelected as -1 this indicates
   * that there isn't selected a search
   */
  clearSearchIdSelected () {
    this.setSearchIdSelected(UNDEFINED_ENTITY_ID)
  }

  /**
   * Copy the 'filters' values into the 'filters' variable
   *
   * @param filters values to copy
   */
  setFiltersWith (filters?: FillgridFilters) {
    this.filters = Object.assign({}, filters)
  }

  /**
   * Set the 'creating' value as the state of creating search
   * @param creating value
   */
  setCreatingSearch (creating: boolean) {
    this.creatingSearch = creating
  }

  /**
   * Set the 'state' value to the searchUpdated variable
   *
   * @param state value to set
   */
  setSearchUpdated (state: number) {
    this.searchUpdated = state
  }

  /**
   * Set the 'state' value to the searchUpdated variable
   *
   * @param state value to set
   */
  updateAllUsersAndActiveUsers (allUsersNames: string[], activeUsersNames: string[] = []) {
    this.users = allUsersNames
    this.activeUsersNames = activeUsersNames
  }

  /**
   * Set the 'searchId' value to 'searchIdSelected' variable
   *
   * @param searchId id to set
   */
  setSearchIdSelected (searchId: number): void {
    this.searchIdSelected = searchId
  }

  /**
   * Set the 'viewId' value to 'viewSelected' variable
   *
   * @param viewId to set to the
   */
  setViewIdSelected (viewId: number): void {
    this.viewSelected = viewId
  }

  /**
   * Deletes the search with id 'searchId'
   * and clear the current search selected
   *
   * @param searchId id of the search to delete
   */
  deleteSearch (searchId: number) {
    fillgridService.deleteSearch(this.templateId, searchId)
      .then(() => {
        let index = this.searches.findIndex((search) => search.id === searchId)
        this.searches.splice(index, 1)
      })
      .then(() => {
        this.clearSearchIdSelected()
        this.newSearch(this.filters)
      })
  }

  /**
   * Creates or updates a custom search.
   * If the searchId is provided, it tries to update that.
   * otherwise it creates a new custom search.
   *
   * @param filters values to with create/update a Search
   * @param searchId id of the search to update
   */
  async saveSearch (filters: FillgridFilters, searchId?: number) {
    const search = this.prepareCustomSearch({ ...filters })
    if (searchId && searchId > 0) {
      search.id = searchId
      this.updateCustomSearchById(searchId, search)
    } else {
      this.createCustomSearch(search)
    }
  }

  updateCustomSearchById (searchId: number, searchValues: CustomSearch): void {
    fillgridService.updateSearch(this.templateId, searchValues)
      .then((response) => {
        let index = this.searches.findIndex((s) => s.id === searchId)
        this.searches.splice(index, 1, response as CustomSearch)
        this.setSearchIdWithProcessState(response.id, PROCESS_STATUS.SUCCESS)
      })
      .catch((error) => {
        this.handleSearchErrorOnSave(error)
      })
      .finally(() => {
        this.setCreatingSearch(false)
      })
  }

  createCustomSearch (searchValues: CustomSearch): void {
    fillgridService.createSearch(this.templateId, searchValues)
      .then((response) => {
        this.unshiftSearch(response)
        this.setSearchIdWithProcessState(response.id, PROCESS_STATUS.SUCCESS)
      })
      .catch((error) => {
        this.handleSearchErrorOnSave(error)
      })
      .finally(() => {
        this.setCreatingSearch(false)
      })
  }

  async createTemporaryCustomSearch (filters: FillgridFilters): Promise<CustomSearch> {
    try {
      const temporaryCustomSearch = this.prepareCustomSearch({ ...filters })
      temporaryCustomSearch.origin = SearchOrigin.TEMPORAL
      temporaryCustomSearch.name = `temp_search_${Date.now().toString()}`
      const response = await fillgridService.createSearch(this.templateId, temporaryCustomSearch)
      return response
    } catch (error) {
      LogService.log(`Error creating temporary search: ${error}`)
      throw error
    }
  }

  setSearchIdWithProcessState (searchId: number, state: PROCESS_STATUS) {
    this.setSearchIdSelected(searchId)
    this.setSearchUpdated(state)
  }

  handleSearchErrorOnSave (error: any) {
    this.manageSearchError(error)
    this.setSearchUpdated(PROCESS_STATUS.ERROR)
  }

  /**
   * Manage an error responsed by the API
   *
   * @param error
   */
  manageSearchError (error: any) {
    let errorData = Object.assign(new APIErrorFormat(), error.response.data)
    if (errorData.isNewErrorFormat()) {
      let blueErrors = errorData.errors
      if (blueErrors.length > 0 && blueErrors[0].code) {
        this.searchError = blueErrors[0].description
      } else {
        this.searchError = blueErrors[0].description
      }
    } else {
      this.searchError = error.response.data.message
    }
  }

  /**
   * Create a CustomSearch based on an object with the values
   *
   * @param filters values from where create a custom search
   */
  prepareCustomSearch (filters: FillgridFilters): CustomSearch {
    return fillgridService.fillgridFiltersToCustomSearch(filters, this.viewSelected)
  }

  backToTemplates () {
    this.$router.push({ name: 'fillgridTemplate' })
  }

  toggleDisplayImages () {
    this.displayImages = !this.displayImages
  }

  /** Items selection */

  /**
   * Reset the selectedItems list to an empty list
   */
  clearSelectedItems (): void {
    this.selectedItems = []
  }

  toggleAllItemsSelection (checked: boolean) {
    this.toggleAll = checked
    if (checked) {
      this.selectedItems = this.items.map((item) => item._id)
    } else {
      this.clearSelectedItems()
    }
  }

  selectItem (checked: boolean, item: any) {
    if (checked) {
      this.selectedItems = [...this.selectedItems, item._id]
      if (this.items.every((item) => this.selectedItems.includes(item._id))) {
        this.toggleAll = true
      }
    } else {
      this.selectedItems = this.selectedItems.filter((itemId) => itemId !== item._id)
      this.toggleAll = false
    }
  }

  /** Fetch data */

  /**
   * Updates the fill value by the cookie 'UPDATE_FILL_IN_FILLGRID'
   * if it exists, it contains a 'fillName' value
   */
  async updateManageFill () {
    const fillName = cookiesService.get(BM_COOKIES.UPDATE_FILL_IN_FILLGRID)
    if (fillName) {
      // Get the latest fill
      await fillgridService.getFillDetail(this.templateId, fillName, { last: true })
        .then((fill: any) => {
          // this cookie is not required anymore
          cookiesService.remove(BM_COOKIES.UPDATE_FILL_IN_FILLGRID)
          const fillEntry = fillgridService.getFillsColumnsData(this.columns, fill)
          // Remove the previous fill value and update to the latest
          this.uploadpages(fillEntry[0])
        })
    }
  }

  uploadpages (lastUpdateItem: any) {
    let deleteItem: any
    let addItem, lastDeleteItem
    for (let i = 1; i <= this.cursorRequest.currentPage; i++) {
      addItem = i === 1 ? lastUpdateItem : lastDeleteItem
      deleteItem = i === this.cursorRequest.currentPage ? lastUpdateItem : (this.pagesLoaded[i] as any[])[this.PAGE_SIZE - 1]
      lastDeleteItem = deleteItem
      let newItems: any[] = this.pagesLoaded[i]
      newItems = newItems.filter((f) => f.name !== deleteItem.name)
      newItems.unshift(addItem)
      this.pagesLoaded[i] = newItems
    }
  }

  async loadPage (page: number) {
    this.clearSelectedItems()
    this.cursorRequest.currentPage = page
    if (this.pagesLoaded[this.cursorRequest.currentPage]) {
      this.items = this.pagesLoaded[this.cursorRequest.currentPage]
    } else {
      await this.searchData()
    }
  }

  async changeSize (size:number) {
    this.PAGE_SIZE = size
    this.cursorRequest.limit = this.PAGE_SIZE
    if (this.items.length !== 0) {
      this.newSearch()
    }
  }

  async reloadData () {
    this.clearSelectedItems()
    if (this.cursorHistory.hasOwnProperty(this.cursorRequest.currentPage)) {
      await this.searchData(this.cursorHistory[this.cursorRequest.currentPage])
    } else {
      await this.searchData()
    }
  }

  async searchData (cursor?: string) {
    if (this.loadingData && !this.downloadingData) return
    this.loadingData = true

    try {
      const dataRequest = {
        templateId: this.templateId,
        cursorRequest: this.cursorRequest,
        cursor: cursor ?? this.cursorRequest.cursor,
        customSearchId: this.temporaryCustomSearchId,
        requestByFTS: this.doRequestsByFTS
      }
      if (this.totalItems === 0) {
        const total = await fillgridService.getCountFills(dataRequest.templateId, dataRequest.cursorRequest, dataRequest.cursor, dataRequest.customSearchId, dataRequest.requestByFTS)
        this.totalItems = total
        this.totalPages = Math.ceil(this.totalItems / this.cursorRequest.limit)
      }
      const fillgridEntries = await fillgridService.getFills(dataRequest.templateId, dataRequest.cursorRequest, dataRequest.cursor, dataRequest.customSearchId, dataRequest.requestByFTS)

      if (!this.cursorHistory.hasOwnProperty(this.cursorRequest.currentPage)) {
        this.cursorHistory[this.cursorRequest.currentPage] = this.cursorRequest.cursor
      }
      this.cursorRequest.cursor = fillgridEntries.nextCursor
      const dataItems = fillgridService.getFillsColumnsData(this.columns, fillgridEntries.results)
      this.pagesLoaded[this.cursorRequest.currentPage] = dataItems

      if (!this.downloadingData) {
        this.items = dataItems
      }

      setTimeout(() => {
        this.loadingData = false
      }, 500)
    } catch (error) {
      this.loadingData = false
      this.handleSearchDataError(error)
    }
  }

  handleSearchDataError (error: any) {
    if ('response' in error && (error as any).response.data && (error as any).response.data.errors && (error as any).response.data.errors[0]) {
      let errorMessage = 'Ocurrió un error al consultar los datos'
      switch ((error as any).response.data.errors[0].code) {
        case 1661:
          errorMessage = 'El rango de fechas excede el límite de 90 días'
          break
        case 1665:
          errorMessage = 'No cuenta con permisos para acceder al -user- solicitado'
          break
        case 1707:
          errorMessage = 'No cuenta con permisos para acceder al -altUser- solicitado'
          break
      }

      this.$bvToast.toast(errorMessage, {
        title: 'Error',
        variant: 'danger',
        solid: true,
        autoHideDelay: 6000,
        toaster: 'b-toaster-top-left'
      })
    } else {
      this.$bvToast.toast('Ocurrió un error al consultar los datos', {
        title: 'Error',
        variant: 'danger',
        solid: true,
        autoHideDelay: 4000,
        toaster: 'b-toaster-top-left'
      })
    }
  }

  simulateSearch (secondsToWait: number) {
    if (this.isUpdating) {
      this.updateManageFill()
      this.isUpdating = false
    } else {
      this.$bvToast.toast(`No hay cambios en los filtros de búsqueda, espera ${secondsToWait} segundos para poder consultar las tareas nuevamente.`, {
        title: 'Búsqueda sin cambios',
        solid: true,
        variant: 'primary',
        autoHideDelay: 7_000,
        toaster: 'b-toaster-top-left'
      })
    }
  }

  async newSearch (filters?: FillgridFilters) {
    this.initVariables(filters)
    this.clearSelectedItems()
    this.setDoRequestsByFts()
    if (!this.doRequestsByFTS && this.isUrlLengthExceeded(this.filters, this.cursorRequest.cursor)) {
      await this.setTemporaryCustomSearch()
    } else {
      this.clearTemporaryCustomSearch()
    }
    this.loadPage(1)
  }

  isUrlLengthExceeded (filters: FillgridFilters, cursor: string): boolean {
    const cursorRequestToValidate = new CursorRequest<FillgridFilters>(this.PAGE_SIZE, true)
    cursorRequestToValidate.filters = filters
    const urlParamsToValidate = fillgridService.prepareGETParams(cursorRequestToValidate, true, cursor)
    return urlParamsToValidate.toString().length > URL_SEARCH_PARAMS_MAX_LENGTH
  }

  /**
   * Initialize the variables to make a new search
   */
  initVariables (filters?: FillgridFilters) {
    this.setFiltersWith(filters || this.filters)
    this.cursorRequest.filters = this.filters
    this.cursorRequest.currentPage = 1
    this.cursorRequest.cursor = ''
    this.totalItems = 0
    this.totalPages = 0
    this.items = []
    this.pagesLoaded = {}
    this.paginatorKey = new Date().getTime()
    this.downloadCurrentPage = 1
    this.cursorHistory = { 1: '' } as any
  }

  applyView (payload: { selection: any[], viewId: any }) {
    this.columnsToShow = payload.selection
    this.viewSelected = payload.viewId
    this.getAttachmentsFromColumns(this.columns, this.columnsToShow)
  }

  isColumnVisible (columnName: string) {
    return !(this.noVisibleColumns.includes(columnName) ||
      (this.columnsToShow.length && this.columnsToShow.indexOf(FillgridColumn.getColumnName(columnName)) === -1))
  }

  /**
   * Validate if a column will be able to modify
   * We can pass an object with the properties to consider as editable field
   *
   * @param column to valdidate if it is able to edit
   * @param check object with flags to consider
   */
  isEditableColumn (column: FillgridColumn, check: any = { readOnly: true }) {
    if (this.isFieldAlreadySelectedToUpdate(column)) return false
    if (column.isEditableColumnDate()) return true
    if (column.base) return false
    if (column.questionRef.identity) return false
    if (check.readOnly && !column.questionRef.readOnly) return false
    if (
      ['signature', 'photo', 'audio', 'pdf', 'location', 'file'].includes(column.type) ||
      ['_id', '_name', '_priority', '_visitedLocation'].includes(column.name) ||
      !column.label || !column.label.trim()
    ) return false
    return true
  }

  /**
   * Validate if the column is editable in the Modify or Manage actions
   * for the fill records.
   */
  isQuickEditEditableColumn (column: FillgridColumn): boolean {
    const check = { readOnly: false }
    return this.isEditableColumn(column, check) && this.isQuickEditField(column)
  }

  /**
   * Validate when a column (field) is of type quick edit
   * this is: a field of type 'selection' with the 'quickEdit' flag on.
   */
  isQuickEditField (column: FillgridColumn) {
    return column.type === TemplateQuestionsTypes.SELECT &&
      column.questionRef.quickEdit
  }
  /**
   * Validate when a column (field) is of type PDF
   */
  isPdfField (column: FillgridColumn) {
    return column.type === TemplateQuestionsTypes.PDF
  }

  isFieldAlreadySelectedToUpdate (column: FillgridColumn): boolean {
    return this.fieldsListToUpdate.some(it => it.name === column.name)
  }

  validateEditableColumn (column: FillgridColumn): boolean {
    return this.updatesMode === FILL_UPDATE_MODE.MODIFY
      ? this.isEditableColumn(column)
      : this.isQuickEditEditableColumn(column)
  }

  /** Media viewer */

  showMediaViewer (type: TemplateQuestionsTypes, src: any, question: string) {
    if (src === undefined || src === null) { return }
    this.currentMediaTypeDisplayed = type
    this.currentMediaSourceDisplayed = src
    switch (type) {
      case TemplateQuestionsTypes.PHOTO:
      case TemplateQuestionsTypes.AUDIO:
      case TemplateQuestionsTypes.PDF:
        this.fetchFile(src, question).then(url => {
          src.url = url
          this.currentMediaSourceDisplayed = src
          this.$bvModal.show('media-viewer-modal')
        })
        break
      default: // Locations
        this.$bvModal.show('media-viewer-modal')
    }
  }

  getFillColumnDateFormat (date: string, isUTC: boolean, questionFormat?: string) {
    const format = questionFormat ? questionFormat.toLocaleUpperCase() : 'DD/MM/YYYY'
    const strictFormat = questionFormat ? format : undefined
    return isUTC ? moment.utc(date, strictFormat).local().format(format) : moment(date, strictFormat).format(format)
  }

  getFillColumnDateTimeFormat (date: string, isUTC: boolean, questionFormat?: string, timeFormat?:string) {
    const format = questionFormat && timeFormat ? questionFormat.toLocaleUpperCase().concat(' ', timeFormat) : 'DD/MM/YYYY - HH:mm:ss'
    const strictFormat = questionFormat && timeFormat ? format : undefined
    if (!isUTC && date.endsWith('Z')) date = date.replace('Z', '')
    return isUTC ? moment.utc(date, strictFormat).local().format(format) : moment(date, strictFormat).format(format)
  }

  getAllLocationColumns (columnsExceptions: string[]) : any[] {
    return this.columns
      .filter((column) => (column.type === this.QUESTION_TYPES.LOCATION && !columnsExceptions.includes(column.name)) ||
                          (column.type === this.QUESTION_TYPES.PHOTO &&
                              !columnsExceptions.includes(column.name) &&
                              column.questionRef.isLocalized
                          )
      )
  }

  getAllLocationValuesFromFill (fill: any, locationExceptions: string[]) {
    // Name list of all columns of type LOCATION
    const locationColumnNames = this.getAllLocationColumns([
      '_visitedLocation',
      ...locationExceptions
    ]).map((column) => column.name)
    const locationsValues = []
    for (const field in fill) {
      if (locationColumnNames.includes(field)) {
        locationsValues.push({
          label: this.getColumnByName(field)?.label,
          ...fill[field]
        })
      }
    }
    return locationsValues
  }

  getColumnByName (name: string) {
    return this.columns.find((column) => column.name === name)
  }

  get displayImagesBtnTitle () {
    return this.displayImages ? 'Ocultar imágenes' : 'Mostrar imágenes'
  }

  getTitleShowMapView () {
    return this.mapViewActive ? 'Ocultar mapa' : 'Mostrar mapa'
  }

  /** UPDATES */

  openAssignUser () {
    if (this.validateSelection()) {
      this.assignationUser = ''
      this.activeAssignRows = false
      this.$bvModal.show('assign-user-modal')
    }
  }

  async saveAssignationUser () {
    if (this.assignationUser) {
      const fillsItems = this.items.reduce((arr: any[], it: any) => this.selectedItems.includes(it._id) ? arr.concat(it) : arr, [])
      let errorMessages = ''
      let erroresList = []

      this.loadingData = true

      let promises: Promise<any>[] = []

      for (let i = 0; i < fillsItems.length; i++) {
        if (i % MAX_SIMULTANEUS_REQUESTS === 0) await fillgridService.timeoutSleep(TIME_SIMULTANEUS_REQUESTS_WAIT)
        promises.push(fillgridService.assignFillToUser(this.templateId, fillsItems[i], this.assignationUser))
      }

      Promise.allSettled(promises).then(results => {
        results.forEach((it) => {
          if (it.status === 'rejected') {
            const error = (it.reason as any).response!.data!.error || (it.reason as any).response!.data!.errors[0]!.description
            if (error && !errorMessages.includes(error)) {
              errorMessages += `\n${error}`
              erroresList.push(error)
            }
          }
        })

        if (errorMessages) {
          this.$bvToast.toast(`Ocurrieron errores al asignar el usuario: \n${errorMessages}`, {
            title: 'Error',
            solid: true,
            variant: 'danger',
            noAutoHide: true,
            bodyClass: 'toast-pre-wrap-content'
          })
        } else {
          this.$bvToast.toast('Los fills han sido asignados correctamente al usuario ' + this.assignationUser, {
            title: 'Listo',
            solid: true,
            variant: 'success',
            autoHideDelay: 4000
          })
        }

        this.$bvModal.hide('assign-user-modal')
        setTimeout(async () => {
          this.loadingData = false
          this.clearSelectedItems()
          await this.reloadData()
        }, 2000)
      })
    }
  }

  /** DELETE */

  openDeleteRows () {
    if (this.validateSelection()) {
      this.activeDeleteRows = false
      this.$bvModal.show('delete-rows-modal')
    }
  }

  async deleteRows () {
    const fillsNames = this.items.reduce((arr: any[], it: any) => this.selectedItems.includes(it._id) ? arr.concat({ id: it._id, name: it._name }) : arr, [])
    let errorMessages = ''
    let erroresList = []

    this.$bvModal.hide('delete-rows-modal')
    this.loadingData = true

    let promises: Promise<any>[] = []

    for (let i = 0; i < fillsNames.length; i++) {
      if (i % MAX_SIMULTANEUS_REQUESTS === 0) await fillgridService.timeoutSleep(TIME_SIMULTANEUS_REQUESTS_WAIT)
      promises.push(fillgridService.deleteFill(this.templateId, fillsNames[i].name))
    }

    Promise.allSettled(promises).then(results => {
      results.forEach((it) => {
        if (it.status === 'rejected') {
          const error = (it.reason as any).response!.data!.error
          if (error && !errorMessages.includes(error)) {
            errorMessages += `\n${error}`
            erroresList.push(error)
          }
        }
      })

      if (errorMessages) {
        this.$bvToast.toast(`Ocurrieron errores al eliminar: \n${errorMessages}`, {
          title: 'Error',
          solid: true,
          variant: 'danger',
          noAutoHide: true,
          bodyClass: 'toast-pre-wrap-content'
        })
      } else {
        this.$bvToast.toast('Los registros han sido eliminados correctamente', {
          title: 'Listo',
          solid: true,
          variant: 'success',
          autoHideDelay: 4000
        })
      }

      setTimeout(async () => {
        this.loadingData = false
        this.clearSelectedItems()
        await this.reloadData()
      }, 2000)
    })
  }

  /* HISTORY */
  get lastHistoryItem () {
    return this.itemsHistory.find(it => it._last === true)
  }

  get enabledHistoryItemToReset () {
    return this.historyActive &&
      this.selectedHistoryItem !== null &&
      this.validateHistoryItem(this.itemsHistory.find(it => it._id === this.selectedHistoryItem)) &&
      this.lastHistoryItem?._altUser === BMP_USER
  }

  async showFillHistory (item?: any) {
    // If the history is already active, do nothing
    if (this.historyActive) return

    try {
      const fill = this.items.find((it) => it._id === item._id)
      const fillName = fill?._name
      this.selectedFillHistoryName = fillName
      this.loadHistoryDataByName(fillName)
      this.openHistory()
    } catch (error) {
      LogService.error('Error loading fill history: ' + error)
      this.closeHistory()
    }
  }

  async loadHistoryDataByName (fillName: string | null = this.selectedFillHistoryName) {
    this.loadingData = true
    if (fillName === null) return

    try {
      const historyData = await fillgridService.getFillDetail(this.templateId, fillName, {}) as any
      this.itemsHistory = fillgridService.getFillsColumnsData(this.columns, historyData)
      this.$bvToast.toast(this.$t('fillgrid.toast.historyLoaded').toString(), {
        title: this.$t('fillgrid.toast.historyLoadedTitle').toString(),
        solid: true,
        variant: 'success',
        autoHideDelay: 4_000,
        toaster: 'b-toaster-top-left'
      })
    } catch (error) {
      this.$bvToast.toast(this.$t('fillgrid.toast.historyLoadError').toString(), {
        title: this.$t('fillgrid.toast.historyLoadErrorTitle').toString(),
        solid: true,
        variant: 'danger',
        autoHideDelay: 4_000,
        toaster: 'b-toaster-top-left'
      })
      throw error
    } finally {
      this.loadingData = false
    }
  }

  handleOnClickItem (item: any) {
    if (this.historyActive) {
      this.selectHistoryItem(item)
    } else {
      this.selectItem(!this.selectedItems.includes(item._id), item)
    }
  }

  validateHistoryItem (item: any, invalidStatuses: string[] = [...AllowedFillResetStatuses]) {
    return invalidStatuses.includes(item.status)
  }

  selectHistoryItem (item: any) {
    if (!this.historyActive || !this.validateHistoryItem(item)) return
    this.selectedHistoryItem = item._id
  }

  async resetHistoryItem (onSuccess: () => void) {
    if (!this.activeResetHistoryItem) return

    const fillToReset = this.itemsHistory.find(it => it._id === this.selectedHistoryItem)
    if (fillToReset === undefined || this.selectedHistoryItem === null) return

    try {
      this.loadingData = true
      await fillgridService.resetFillToSourceId(
        this.templateId,
        fillToReset._name,
        fillToReset._sourceId,
        Object.fromEntries(
          this.selectedResetHistoryDates.map(date => [date.name.replace(/_/g, ''), date.value || undefined])
        )
      )
      const successToastTitle = this.$t('fillgrid.toast.resetSuccessTitle').toString()
      const successToastDescription = this.$t('fillgrid.toast.resetSuccess').toString()
      const successToast = {
        title: successToastTitle,
        solid: true,
        variant: 'success',
        autoHideDelay: 4_000,
        toaster: 'b-toaster-top-left'
      }
      this.$bvToast.toast(successToastDescription, successToast)
      await this.loadHistoryDataByName(fillToReset._name)
      if (onSuccess) onSuccess()
    } catch (error: any) {
      const errorToastTitle = this.$t('fillgrid.toast.resetErrorTitle').toString()
      const errorToast = {
        title: errorToastTitle,
        solid: true,
        variant: 'danger',
        autoHideDelay: 4_000,
        toaster: 'b-toaster-top-left'
      }
      if (error?.response && error.response.data) {
        const errorData = Object.assign(new APIErrorFormat(), error.response.data)
        const errorDetail = errorData.errors[0] || { description: this.$t('fillgrid.toast.resetErrorGeneric').toString(), code: errorData.code }
        this.$bvToast.toast(`${errorDetail.description} (${this.$t('fillgrid.toast.resetErrorCode', { code: errorDetail.code }).toString()})`, errorToast)
      } else {
        this.$bvToast.toast(`${this.$t('fillgrid.toast.resetErrorGeneric').toString()} (${this.$t('fillgrid.toast.resetErrorCode', { code: 'UNKNOWN' }).toString()})`, errorToast)
      }
    } finally {
      this.clearResetHistoryItem()
      this.loadingData = false
    }
  }

  clearResetHistoryItem () {
    this.selectedHistoryItem = null
    this.defaultResetHistoryDate = ''
    this.selectedResetHistoryDates = []
    this.activeResetHistoryItem = false
  }

  cancelResetHistoryItem (onSuccess: () => void) {
    this.clearResetHistoryItem()
    if (onSuccess) onSuccess()
  }

  closeHistory () {
    this.clearResetHistoryItem()
    this.historyActive = false
  }

  openHistory () {
    this.historyActive = true
  }

  onChangeHistoryDate (value: any) {
    this.selectedResetHistoryDates = [...this.selectedResetHistoryDates, value]
    this.defaultResetHistoryDate = ''
  }

  removeResetHistoryDate (date: any) {
    this.selectedResetHistoryDates = this.selectedResetHistoryDates.filter(selected => selected.name !== date.name)
  }

  get resetHistoryDatesOptions () {
    return this.resetHistoryDates
      .filter(date => this.selectedResetHistoryDates.find(selected => selected.name === date) === undefined)
      .map(date => {
        const column = this.columns.find(col => col.name === date)
        return {
          text: column?.label,
          value: {
            name: column?.name,
            label: column?.label,
            type: column?.type,
            questionRef: column?.questionRef,
            value: '',
            valid: false
          }
        }
      })
  }

  /** UPDATES */

  openUpdatesMultiple (mode: FILL_UPDATE_MODE) {
    this.updatesMode = mode
    if (this.validateSelection()) {
      this.fieldsListToUpdate = []
      this.activeUpdateMultipleRows = false
      this.$bvModal.show('updates-multiple-modal')
    }
  }

  addFieldToUpdate (field: string) {
    const columnConfig = this.columns.find(it => it.name === field) || {} as any
    this.fieldsListToUpdate.push({ name: columnConfig.name, label: columnConfig.label, type: columnConfig.type, questionRef: columnConfig.questionRef, value: this.getDefaultFieldValue(columnConfig.type, columnConfig.questionRef), valid: false })
    this.fieldToUpdate = ''
    setTimeout(() => {
      const id = 'input-update-' + (this.fieldsListToUpdate.length - 1)
      const element = document.getElementById(id)
      if (element) element.focus()
    }, 500)
  }

  getDefaultFieldValue (type: string, questionRef: any) {
    switch (type) {
      case TemplateQuestionsTypes.SELECT:
        if (questionRef.display.format === 'COMBO') {
          if (questionRef.display.type === 'MULTIPLE') {
            return []
          } else {
            return ''
          }
        }
        break
      default:
        return ''
    }
  }

  deleteFieldToUpdate (index: number) {
    this.fieldsListToUpdate.splice(index, 1)
  }

  get existsDisableSelectedItems () {
    return this.getSelectedItems.some((item) => this.DISABLE_FILL_STATUS.includes(item.status))
  }

  get allDisableSelectedItems () {
    return this.getSelectedItems.every((item) => this.DISABLE_FILL_STATUS.includes(item.status))
  }

  get getSelectedItems () {
    return this.items.filter((item) => this.selectedItems.includes(item._id))
  }

  async applyUpdatesMultiple () {
    if (!this.validFields()) {
      this.$bvToast.toast('Algunos valores ingresados no son correctos', {
        title: 'Validación',
        solid: true,
        autoHideDelay: 3500
      })
      return false
    } else {
      const selectedFills = this.getSelectedItems
      const enableFillsByStatus = selectedFills.filter((fill) => !this.isDisableFillStatus(fill.status))
      let errorMessages = ''
      let erroresList = []

      this.loadingData = true
      const changes = this.getFillsChangesObject()

      let promises: Promise<any>[] = []

      if (this.updatesMode === FILL_UPDATE_MODE.MODIFY) {
        for (let i = 0; i < enableFillsByStatus.length; i++) {
          if (i % MAX_SIMULTANEUS_REQUESTS === 0) await fillgridService.timeoutSleep(TIME_SIMULTANEUS_REQUESTS_WAIT)
          promises.push(fillgridService.updateFill(this.templateId, enableFillsByStatus[i], changes, this.idents))
        }
      } else {
        for (let i = 0; i < enableFillsByStatus.length; i++) {
          if (i % MAX_SIMULTANEUS_REQUESTS === 0) await fillgridService.timeoutSleep(TIME_SIMULTANEUS_REQUESTS_WAIT)
          promises.push(fillgridService.manageFill(this.templateId, enableFillsByStatus[i], changes, this.idents))
        }
      }

      Promise.allSettled(promises).then(results => {
        results.forEach((it) => {
          if (it.status === 'rejected') {
            const error = (it.reason as any).response!.data!.error || (it.reason as any).response!.data!.errors[0]!.description
            if (error && !errorMessages.includes(error)) {
              errorMessages += `\n${error}`
              erroresList.push(error)
            }
          }
        })

        if (errorMessages) {
          this.$bvToast.toast(`Ocurrieron errores al guardar los datos: \n${errorMessages}`, {
            title: 'Error',
            solid: true,
            variant: 'danger',
            noAutoHide: true,
            bodyClass: 'toast-pre-wrap-content'
          })
        } else {
          this.$bvToast.toast('Los fills se han actualizado correctamente', {
            title: 'Listo',
            solid: true,
            variant: 'success',
            autoHideDelay: 4000
          })
        }

        this.$bvModal.hide('updates-multiple-modal')
        setTimeout(async () => {
          this.loadingData = false
          this.clearSelectedItems()
          await this.reloadData()
        }, 2000)
      })
    }
  }

  getFillsChangesObject () {
    const changes: any = { }
    for (let field of this.fieldsListToUpdate) {
      let value = field.value

      switch (field.type) {
        case this.QUESTION_TYPES.DATE:
          value = moment(field.value).format('YYYY-MM-DD')
          break
        case this.QUESTION_TYPES.DATETIME:
          value = moment(field.value).format('YYYY-MM-DDTHH:mm:ss')
          break
        case this.QUESTION_TYPES.TIME:
          value = moment(field.value).format('HH:mm:ss')
          break
      }
      if (FillgridColumn.isEditableColumnDate(field.name)) {
        changes[field.name] = value
      } else {
        changes[field.questionRef.id] = value
      }
    }
    return changes
  }

  validFields () {
    for (let i = 0; i < this.fieldsListToUpdate.length; i++) {
      if (!this.fieldsListToUpdate[i].valid) {
        return false
      }
    }
    return true
  }

  openChangeStatusRows () {
    if (this.validateSelection()) {
      this.activeChangeStatusRows = false
      this.$bvModal.show('change-status-rows-modal')
    }
  }

  async changeStatusRows () {
    const fillsItems = this.items.reduce((arr: any[], it: any) => this.selectedItems.includes(it._id) ? arr.concat(it) : arr, [])
    let errorMessages = ''
    let errorNotBmp = 'Solo se puede generar PDF a los registros que ya se encuentren gestionados.'
    let erroresList = []
    let successPdf = false

    this.$bvModal.hide('change-status-rows-modal')
    this.loadingData = true

    let promises: Promise<any>[] = []

    for (let i = 0; i < fillsItems.length; i++) {
      if (fillsItems[i]._altUser === BMP_USER) {
        if (i % MAX_SIMULTANEUS_REQUESTS === 0) await fillgridService.timeoutSleep(TIME_SIMULTANEUS_REQUESTS_WAIT)
        promises.push(fillgridService.changeStatusFilltoFNL(this.templateId, fillsItems[i]))
      } else {
        if (!errorMessages.includes(errorNotBmp)) {
          errorMessages += `\n${errorNotBmp}`
          erroresList.push(errorNotBmp)
        }
      }
    }

    Promise.allSettled(promises).then(results => {
      results.forEach((it) => {
        if (it.status === 'rejected') {
          const error = (it.reason as any).response!.data!.error || (it.reason as any).response!.data!.errors[0]!.description
          if (error && !errorMessages.includes(error)) {
            errorMessages += `\n${error}`
            erroresList.push(error)
          }
        } else {
          successPdf = true
        }
      })

      if (errorMessages) {
        this.$bvToast.toast(`Ocurrieron errores al generar el PDF: \n${errorMessages}`, {
          title: 'Error',
          solid: true,
          variant: 'danger',
          noAutoHide: true,
          bodyClass: 'toast-pre-wrap-content'
        })
      }
      if (successPdf) {
        this.$bvToast.toast(`A los registros se les ha generado el PDF correctamente`, {
          title: 'Listo',
          solid: true,
          variant: 'success',
          autoHideDelay: 4000
        })
      }

      setTimeout(async () => {
        this.loadingData = false
        this.clearSelectedItems()
        await this.reloadData()
      }, 5000)
    })
  }

  /** DOWNLOAD FILES & DATA */

  fetchPhotoPreview (entryColumnValue: any, question: string) {
    this.fetchFile(entryColumnValue, question).then(url => {
      entryColumnValue.url = url
    })
  }

  fetchFile (entryColumnValue: any, question: string) {
    return new Promise((resolve, reject) => {
      if (entryColumnValue.url) {
        resolve(entryColumnValue.url)
      } else {
        fillgridService.getFillgridFileAttachement(entryColumnValue.name, question, this.templateId).then(url => {
          resolve(url)
        })
      }
    })
  }

  downloadFile (name: string, question: string) {
    this.downloadingFileItem = name
    fillgridService.getFillgridFileWithoutTypeAttachement(name, question, this.templateId).then((data: any) => {
      const link = document.createElement('a')
      link.href = data.url
      link.download = data.filename
      link.style.display = 'none'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }).finally(() => {
      this.downloadingFileItem = ''
    })
  }

  openDownloadFiles () {
    if (this.validateSelection()) {
      this.$bvModal.show('download-files-modal')
    }
  }

  downloadFiles () {
    this.$bvModal.hide('download-files-modal')
    this.$bvToast.toast('La liga para descargar los archivos ha sido enviada al correo proporcionado', {
      title: 'Archivos enviados',
      solid: true,
      autoHideDelay: 4000
    })
  }

  /** POPUPS **/
  baseURLToRedirect (): string {
    return config.isProduction
      ? `https://${config.enviroment}.${config.appDomain}`
      : `http://${config.appDomain}:2680/bmp-3.1`
  }

  openFillDetail (fill: any) {
    if (this.hasPermissionToEditFills) {
      let URL = `${this.baseURLToRedirect()}/fill.xsp?view=form&id=${fill._id}&template=${this.templateId}`
      URL = this.addParamsFromFillgrid(URL)
      this.redirectWindowToHref(URL)
    }
  }

  openFillNew () {
    let URL = `${this.baseURLToRedirect()}/fill.xsp?view=form&id=-1&template=${this.templateId}`
    URL = this.addParamsFromFillgrid(URL)
    this.redirectWindowToHref(URL)
  }

  openFillInTypist (fill?: any) {
    if (this.historyActive) return
    if (this.hasTypistPermission) {
      let TYPIST_URL = ''
      // prepare URL base on the fill
      if (fill === undefined) {
        TYPIST_URL = `${this.baseURLToRedirect()}/typist.xsp?fillName=new&template=${this.templateId}`
      } else {
        TYPIST_URL = `${this.baseURLToRedirect()}/typist.xsp?fillName=${fill._name}&template=${this.templateId}`
      }
      // TYPIST_URL = this.addParamsFromFillgrid(TYPIST_URL)
      // redirect to the URL
      this.redirectWindowToHref(TYPIST_URL)
      this.isUpdating = true
    } else {
      if (fill === undefined) {
        this.openFillNew()
      } else {
        this.openFillDetail(fill)
      }
    }
  }

  @Provide()
  readonly openFillInTypistFromMap = this.openFillInTypist

  addOriginParamToURL (url: string, origin: string) {
    return url + `&origin=${origin}`
  }

  addPageHistoryParamToURL (url: string, index: number) {
    return url + `&page-history=${index}`
  }

  addParamsFromFillgrid (url: string) {
    url = this.addOriginParamToURL(url, this.ORIGIN_PARAM)
    url = this.addPageHistoryParamToURL(url, NUMBER.ONE)
    return url
  }

  redirectWindowToHref (href: string) {
    if (window.top!) {
      window.top!.location.href = href
    } else {
      window.location.href = href
    }
  }

  /** UTIL METHODS **/

  validateSelection (): boolean {
    if (this.selectedItems.length) {
      return true
    } else {
      this.$bvToast.toast('Seleccione al menos un registro', {
        title: 'Acción requerida',
        solid: true,
        variant: 'warning',
        autoHideDelay: 3200,
        toaster: 'b-toaster-top-left'
      })
      return false
    }
  }

  getFieldSelectPriorityValue (options: any, propertyValue: string) {
    for (let it of Object.entries(options)) {
      if (it[1] === propertyValue) return it[0]
    }
    return ''
  }

  isSomeTaskInProcess (): boolean {
    return this.$store.getters['taskNotifications/isDatafeedTaskInProcess']
  }

  setExistTaskInProcess (value: boolean): void {
    this.existTaskInProcess = value
  }

  currencyFormat (value: number | undefined, maxDecimal: number): string {
    if (value === undefined) return ''
    const options: Intl.NumberFormatOptions = { style: 'currency', currency: 'MXN', maximumFractionDigits: maxDecimal ?? 21, minimumFractionDigits: maxDecimal }
    const currencyFormatMX = new Intl.NumberFormat('es-MX', options)
    return currencyFormatMX.format(value)
  }

  decimalFormat (value: number | undefined, maxDecimal: number, thousandsSeparator: boolean = false): string {
    if (value === undefined || value === null) return ''
    if (thousandsSeparator) {
      const options: Intl.NumberFormatOptions = {
        style: 'decimal',
        maximumFractionDigits: maxDecimal,
        minimumFractionDigits: maxDecimal
      }
      const currencyFormatMX = new Intl.NumberFormat('es-MX', options)
      return currencyFormatMX.format(value)
    }
    if (maxDecimal) {
      return value.toFixed(maxDecimal)
    }
    return value.toString()
  }

  integerFormat (value: number | undefined, thousandsSeparator: boolean = false): string {
    if (value === undefined || value === null) return ''
    if (thousandsSeparator) {
      const options: Intl.NumberFormatOptions = {
        style: 'decimal',
        maximumFractionDigits: 0,
        minimumFractionDigits: 0
      }
      const currencyFormatMX = new Intl.NumberFormat('es-MX', options)
      return currencyFormatMX.format(value)
    }
    return value.toString()
  }

  resetIntegrationTaskModal () {
    this.integrationTaskModalKey++
    this.$bvModal.hide('modalIntegration')
  }

  reloadNormalizers () {
    this.isGetListNormalizer = false
    this.loadNormalizers()
  }

  loadNormalizers () {
    fillgridService.getNormalizers(this.templateId).then((response) => {
      this.listNormalizers = response.results
    }).finally(() => {
      this.isGetListNormalizer = true
    })
  }

  openModalIntegration () {
    this.integrationModel = true
    if (this.normalizationPermission && !this.isGetListNormalizer) {
      this.loadNormalizers()
    }
  }

  /**
   * Prepares the payload to show a location question in the media previewer
   *
   * @param value property of fill row
   * @param item fill row
   * @param index property column index
   */
  getLocationPayload (value: any, item: any, index: number) {
    return {
      location: Object.assign({}, value, { label: this.columns[index]?.label }),
      refLocation: Object.assign({}, item._visitedLocation, { label: this.getColumnByName('_visitedLocation')?.questionRef?.label }),
      locations: this.getAllLocationValuesFromFill(item, [this.columns[index]?.name])
    }
  }

  /**
   * Prepares the payload to show a photo question with or without location in the media previewer
   *
   * @param value property of fill row
   * @param item fill row
   * @param index property column index
   */
  getPhotoPayload (value: any, item: any, index: number) {
    if (this.columns[index]?.questionRef?.isLocalized) {
      return Object.assign({}, value, { locations: this.getAllLocationValuesFromFill(item, [this.columns[index]?.name]), label: this.columns[index]?.questionRef?.label })
    } else {
      return value
    }
  }

  async setTemporaryCustomSearch () {
    try {
      const temporaryCustomSearch = await this.createTemporaryCustomSearch(this.filters)
      this.temporaryCustomSearchId = temporaryCustomSearch.id
    } catch (error) {
      this.temporaryCustomSearchId = undefined
      LogService.log(`Error creating temporary custom search: ${error}`)
    }
  }

  clearTemporaryCustomSearch () {
    this.temporaryCustomSearchId = undefined
  }

  setDoRequestsByFts () {
    this.doRequestsByFTS = this.searchByFTS()
  }

  searchByFTS () {
    const random = Math.random() // Generate a pseudorandom number between 0 and 1
    return random < (this.ftsProbabilityPercentage / 100)
  }

  getProbabilityPercentage (key: string, defaultValue: number): number {
    const configValue = this.apiConfiguration.configuration.find(config => config.key === key)?.value
    return configValue ? parseFloat(configValue) : defaultValue
  }

  getFtsProbabilityPercentage (): number {
    return this.getProbabilityPercentage(CONFIGURATION_KEY.MIS_TAREAS_FTS, this.ftsDefaultProbabilityPercentage)
  }
}
</script>

<style lang="scss" scoped>
.fillgrid-view {
  $left-sidebar-width: 272px;
  height: 100%;
  overflow: hidden;
  position: relative;
  height: 100%;
  transition-delay: 500ms;

  &.sidebar-collapsed {
    .left-sidebar {
      left: $left-sidebar-width * -1;
    }
    .right-side {
      left: 0;
    }
  }

  .left-sidebar {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    width: $left-sidebar-width;
    box-shadow: 0 0 12px #ccc;
    display: flex;
    flex-direction: column;
    z-index: 2;
    background-color: #f8f8f8;
    transition: left 200ms ease;

    .toggle-button {
      position: absolute;
      left: calc(100% + 2px);
      top: 8px;
      width: 22px;
      height: 35px;
      background-color: var(--sidebar-bg-color);
      box-shadow: 1px 1px 3px #bbb;
      cursor: pointer;
    }

    .template-name {
      padding: 14px;
      display: flex;
      align-items: center;
      font-size: 0.9rem;
      border-bottom: 1px solid #e2e2e2;

      i {
        font-size: 1.4rem;
        margin-right: 7px;
        cursor: pointer;
      }
    }

    .filters {
      flex: 1;
      overflow: hidden auto;
      padding: 5px 7px 0px 7px;
      .nav-link {
        color: inherit;
        &.active {
          background-color: #ececec;
          font-weight: bold;
          font-size: 0.9rem;
        }
      }
    }
  }

  .right-side {
    z-index: 0;
    overflow: hidden;
    position: absolute;
    top: 0;
    left: $left-sidebar-width;
    right: 0;
    bottom: 0;
    transition: left 200ms ease;

    .top-tool-bar {
      height: 50px;
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      padding: 0 10px 0 35px;
      box-shadow: 0 1px 3px #ccc;
      z-index: 2;
      .action {
        padding: 7px 12px;
        border-right: 1px solid #ddd;
        cursor: pointer;
        font-size: 0.9rem;
        font-weight: 300;
        display: flex;
        align-items: center;
        i {
          margin: 0 3px;
          font-size: 1.1rem;
        }
        &:first-child {
          border-left: 1px solid transparent;
        }
        &:hover, &.active {
          background-color: #f0f0f0;
          border-width: 1px 1px 1px 0;
          border-color: #ddd;
          border-style: solid;
          border-radius: 3px;
          &:first-child {
            border-width: 1px 1px 1px 1px;
          }
        }
      }
      .pagination {
        margin: 0;
        margin-left: auto;
        justify-self: flex-end;
        .page-item {
          a {
            border: 0;
            color: inherit;
            background-color: inherit;
          }
          &.active a {
            background-color: var(--secondary);
            color: #fff;
            border-radius: 4px;
          }
        }
        &.disabled {
          pointer-events: none;
          opacity: 0.75;
        }
      }
      .total {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 6px;
      }
    }

    .table-container {
      position: absolute;
      z-index: -1;
      top: 50px;
      right: 0;
      bottom: 0;
      left: 0;
      overflow-y: auto;

      .data-table {
        width: auto;
        max-height: 100%;
        font-size: 0.9rem;
        position: relative;
        border-collapse: collapse;

        th {
          background-color: #f5f5f5;
          position: sticky;
        }

        $border-th-color: #ddd;
        thead {
          height: 3rem;

          th {
            top: 0;
            box-shadow: 0 1px 1px $border-th-color;
            padding: 10px 20px 4px 8px !important;
            cursor: pointer;
            z-index: 1;
            &:first-child {
              left: 0;
              z-index: 2;
              box-shadow: 1px 1px 1px $border-th-color;
            }
            &.th-selector {
              z-index: 4;

              &.has-permission-to-read,
              &.has-permission-to-edit {
                min-width: 5.875rem;
              }

              &.has-permission-to-read.has-permission-to-edit:not(.--history-activated) {
                min-width: 8.125rem;
              }

              .th-selector-content {
                display: flex;
                align-items: center;
                justify-content: flex-start;
                width: 100%;
              }
            }
            .number {
              position: absolute;
              top: -1px;
              right: 0;
              padding: 0 5px;
              height: 14px;
              font-size: 0.6rem;
              font-weight: 400;
              text-align: center;
              background-color: #dfdfdf;
              border-bottom-left-radius: 10px;
            }
          }
        }

        tbody {
          tr {
            cursor: pointer;

            &.selected,
            &:hover {
              td, th {
                background-color: var(--element-hover-bg-color);
              }
            }
            th {
              left: 0;
              box-shadow: 1px 0 1px $border-th-color;
              z-index: 1;
            }
            td {
              position: relative;
              z-index: 0;
              height: 3rem;
            }
          }
          tr.--history-activated:not(.--history-disabled) {
            &:hover {
              td {
                background-color: var(--element-hover-dark-bg-color);
              }
            }
            &.--history-selected {
              td {
                background-color: var(--warning-bg-color);
              }
              &:hover {
                td {
                  background-color: var(--warning-hover-bg-color);
                }
              }
            }
          }
          tr.--history-activated.--history-disabled {
            th, td {
              background-color: var(--light);
              color: #999;
              cursor: not-allowed;
            }
          }
        }

        th, td {
          padding: 0.25rem 0.5rem;
          max-width: 350px;
          border: 1px solid #eeeeee;
          vertical-align: middle;
          div {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
        th.th-selector {
          z-index: 3;
          padding-right: 1rem;

          .th-selector-content {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            width: 100%;
          }
        }
        th.th-selector.--history-activated {
          min-width: 3.75rem;
        }
        th.th-selector.--history-activated.has-permission-to-reset {
          min-width: 5.875rem;
        }

        th.is-ident {
          background-color: var(--primary);
          color: var(--light);
        }
        th.is-first-column {
          position: sticky;
          left: 3.75rem;
          z-index: 4;
        }
        th.is-first-column.--history-activated.has-permission-to-reset,
        th.is-first-column.has-permission-to-read,
        th.is-first-column.has-permission-to-edit {
          left: 5.875rem;
        }
        th.is-first-column.has-permission-to-read.has-permission-to-edit:not(.--history-activated) {
          left: 8.125rem;
        }

        th.computed-field {
          max-width: 40rem;

          .computed-field__label {
            display: flex;
            flex-direction: column;
            width: 100%;

            .computed-field__label__label {
              margin: 0;
            }

            span {
              display: grid;
              grid-template-columns: 1fr 1fr;
              grid-template-rows: auto;
              width: 100%;

              .computed-field__label__final,
              .computed-field__label__computed {
                margin: 0;
              }
              .computed-field__label__final {
                padding-right: 0.5rem;
                border-right: 1px solid #eee;
              }
              .computed-field__label__computed {
                padding-left: 0.5rem;
              }
            }

          }
        }
        td.is-ident {
          background-color: #E3F2FD;
          color: #000;
          border: 1px solid #fff;
        }
        td.is-first-column {
          position: sticky;
          left: 3.75rem;
          z-index: 3;
        }
        td.is-first-column.has-permission-to-read,
        td.is-first-column.has-permission-to-edit,
        td.is-first-column.--history-activated.has-permission-to-reset {
          left: 5.875rem;
        }
        td.is-first-column.has-permission-to-read.has-permission-to-edit:not(.--history-activated) {
          left: 8.125rem;
        }
        td.computed-field {
          padding-right: 20px;
        }
        .special-field {
          position: absolute;
          top: 0;
          right: 0;
          left: 0;
          bottom: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          min-height: 30px;
          cursor: pointer;
          i {
            font-size: 1.2rem;
            color: var(--green);
            &.missing {
              color: var(--red);
            }
          }
          &.photo {
            position: relative;

            &.displayImages {
              display: block;
              min-width: 20rem;
              min-height: 6rem;
            }

            .image-displayed__content {
              display: flex;
              justify-content: center;
              align-items: center;
              width: 100%;
              height: 100%;
              cursor: initial;

              .image-displayed__details{
                flex: 1 1;
                display: flex;
                flex-direction: column;
              }

              .image-displayed__image {
                flex: 1 1;
                width: 150px;
                height: 150px;
              }
            }
          }
        }
        .priority {
          position: absolute;
          top: 1px;
          right: 0;
          bottom: 1px;
          width: 15px;
        }
        .computed-field__content {
          display: grid;
          grid-template-columns: 1fr 1fr;
          width: 100%;

          .computed-field__final,
          .computed-field__computed {
            margin: 0;
          }
          .computed-field__final {
            padding-right: 0.5rem;
            border-right: 1px solid #eee;
          }
          .computed-field__computed {
            padding-left: 0.5rem;
          }
        }
      }
    }

    .map-container {
      position: absolute;
      z-index: -1;
      top: 50px;
      right: 0;
      bottom: 0;
      left: 0;
      overflow-y: auto;
      display: flex;
    }
  }

  .loading-mask {
    position: absolute;
    z-index: 99;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(#fff, 0.85);
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 45px;
  }
}

.popover-image-preview {
  img {
    width: 200px;
  }
}

.updates-multiple-modal {
  h5 {
    text-align: center;
  }
  .container {
    max-width: 400px;
    margin: 0 auto;
  }
  .fields {
    padding: 20px 0;
    .input-field {
      position: relative;
      margin-bottom: 15px;
      padding: 5px;
      border-radius: 4px;
      .remove {
        position: absolute;
        top: 0;
        right: 0;
        padding: 4px;
        cursor: pointer;
        display: none;
        color: var(--danger);
      }
      &:hover {
        background-color: #f0f0f0;
        .remove {
          display: block;
        }
      }
    }
  }
  .custom-field-selector {
    background-color: #e9e9e9;
    cursor: pointer;
    &:hover {
      background-color: #d8d8d8;
    }
  }
}
.toast.async-task-toast {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;

  &.success .toast-header {
    background-color: #c3e6cb;
    color: #155724;
  }
  &.success .toast-body {
    color: #155724;
    background-color: #d4edda;
    border-color: #c3e6cb;
    p {
      margin: 0
    }
    span {
      font-weight: bold;
    }
    .task-id {
      font-size: 1rem;
    }
  }
}
.reset-history-item-modal__inputs {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 1rem;
  padding: 0 1.5rem;
}
.reset-history-item-modal__inputs__item {
  position: relative;
  padding: 0.5rem 1rem;
  margin-bottom: 0.5rem;
  border-radius: 0.5rem;

  .reset-history-item-modal__inputs__item__remove-date {
    position: absolute;
    top: 0;
    right: 0;
    margin: 0.5rem 1rem;
    cursor: pointer;
    display: none;
    color: var(--danger);
  }
  &:hover {
    background-color: var(--element-hover-bg-color);

    .reset-history-item-modal__inputs__item__remove-date {
      display: block;
    }
  }
}
.reset-history-item-modal__select-date {
  padding: 0 1rem;
  margin-bottom: 1rem;
}
</style>
